// Токен
var tokenData = $('meta[name=token]').attr('content');


// Модалка вопросов, подгрузка по ajax

$(document).on('click', '.faq .faq__btn', function (e) {
    e.preventDefault();
    topQuest.openModal();

    var faqWrap = $('#top-quest .faq__wrap');

    $('#top-quest .sm-modal-contant').addClass('preloader');

    setTimeout(function () {
        $('#top-quest .sm-modal-contant').removeClass('preloader');
    }, 2000);

    let dataAjax = {
        restaurant_id: $(this).data('id'),
        _token: tokenData,
    }

    // console.log(data);

    $.ajax({
        url: '/order/faqs',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;

            // Очистка враппера с вопросами
            faqWrap.html('');

            // Вывод вопросов
            for (let index = 0; index < result.length; index++) {
                const quest = result[index];
                var faqQuest = quest.question;
                var faqText = quest.answer;
                faqWrap.append(`
                    <div class="faq__el">
                        <div class="faq__el-title">
                            ${faqQuest}
                        <div class="faq__el-title-close"> <span></span></div>
                        </div>
                        <div class="faq__el-text">
                            <p>${faqText}</p>
                        </div>
                    </div>`);
            };

            // Убрать прелоадер
            $('#top-quest .sm-modal-contant').removeClass('preloader');

        }
    });
});


// Модалка отзывов, подгрузка по ajax
$(document).on('click', '.rating .rating__btn', function (e) {
    e.preventDefault();
    rewiewsMod.openModal();

    var rewWrap = $('#rewiews-mod .rewiews-mod__grid');

    $('#rewiews-mod .sm-modal-contant').addClass('preloader');

    let dataAjax = {
        restaurant_id: $(this).data('id'),
        _token: tokenData,
    }

    $.ajax({
        url: '/order/reviews',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;

            // Очистка враппера с отзывами
            rewWrap.html('');

            // Вывод отзывами
            for (let index = 0; index < result.length; index++) {
                const rew = result[index];

                var rewImg = rew.image,
                    rewNameDate = rew.name_and_date,
                    rewRat = rew.rating,
                    rewText = rew.text,
                    rewStarItog = ``,
                    rewStar = `<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.13163 0.520517C9.51547 -0.151585 10.4845 -0.151584 10.8684 0.520519L13.2937 4.76732C13.4359 5.01627 13.6781 5.19222 13.9588 5.25051L18.7472 6.24481C19.505 6.40217 19.8045 7.3238 19.2839 7.89654L15.9944 11.5155C15.8016 11.7277 15.7091 12.0124 15.7404 12.2973L16.2744 17.1586C16.3589 17.928 15.575 18.4976 14.8694 18.1795L10.411 16.1693C10.1497 16.0515 9.85032 16.0515 9.58897 16.1693L5.13063 18.1795C4.42504 18.4976 3.64106 17.928 3.72558 17.1586L4.25964 12.2973C4.29095 12.0124 4.19844 11.7277 4.00561 11.5155L0.716139 7.89655C0.195544 7.3238 0.494998 6.40217 1.25282 6.24481L6.04123 5.25051C6.32193 5.19222 6.56412 5.01627 6.70629 4.76732L9.13163 0.520517Z" fill="#FF9900"></path></svg>`;

                // Количество звездочек рейтинга
                for (let index = 0; index < rewRat; index++) {
                    rewStarItog = rewStarItog + rewStar;
                    console.log(rewStarItog);
                }

                rewWrap.append(`
                    <div class="rating__slider-el swiper-slide">
                        <div class="rating__slider-el-img"><img src="${rewImg}" alt=""></div>
                        <div class="rating__slider-el-stars">
                            ${rewStarItog}
                        </div>
                        <div class="rating__slider-el-text">
                            ${rewText}
                        </div>
                        <div class="rating__slider-el-name">${rewNameDate}</div>
                    </div>`);
            };

            // Убрать прелоадер
            $('#rewiews-mod .sm-modal-contant').removeClass('preloader');

        }
    });
});


// Подгрузка альбомов
$(document).on('click', '.galery .galery__btn', function (e) {
    e.preventDefault();

    let dataAjax = {
            restaurant_id: $(this).data('id'),
            _token: tokenData,
            offset: $('.galery').find('.galery__wrap').length
        },
        galeryCont = $('.galery'),
        thisBtn = $(this);

    $.ajax({
        url: '/order/albums',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            // Вывод галлерей
            for (let index = 0; index < result.length; index++) {
                const sld = result[index];

                var sldName = sld.name,
                    slides = ``,
                    slidesNum = sld.images.length,
                    galleruNum = index + 4;

                // Количество слайдов
                for (let index = 0; index < slidesNum; index++) {

                    var galleryImg = sld.images[index];

                    var slide = `<a class="galery__slider-el swiper-slide" href="${galleryImg}" data-fancybox="gallery${galleruNum}">
                                    <img src="${galleryImg}" alt="">
                                </a>`;
                    slides = slides + slide;
                }

                galeryCont.find('.galery__btn').before(`
                <div class="galery__wrap">
                    <p class="galery__uptitle">${sldName}</p>
                    <div class="galery__slider swiper-container galery__slider1">
                        <div class="galery__slider-wrap swiper-wrapper">
                            ${slides}
                        </div>
                    </div>
                    <div class="galery__slider-nav">
                        <div class="slider-proj-prev galery__slider-prev galery__slider-prev1 swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-disabled="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1415 17.4101C11.9075 17.2839 11.7616 17.0438 11.7616 16.7827V12.7173H3.73429C3.32896 12.7173 3 12.396 3 12C3 11.6041 3.32896 11.2828 3.73429 11.2828H11.7616V7.21731C11.7616 6.95527 11.9075 6.71523 12.1415 6.58995C12.3755 6.46275 12.6614 6.47136 12.8875 6.61003L20.6573 11.3927C20.8708 11.5247 21 11.7533 21 12C21 12.2468 20.8708 12.4753 20.6573 12.6073L12.8875 17.39C12.7681 17.4627 12.632 17.5 12.4959 17.5C12.3745 17.5 12.2521 17.4694 12.1415 17.4101Z" fill="white"></path> </svg></div>
                        <div class="slider-proj-next galery__slider-next galery__slider-next1" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1415 17.4101C11.9075 17.2839 11.7616 17.0438 11.7616 16.7827V12.7173H3.73429C3.32896 12.7173 3 12.396 3 12C3 11.6041 3.32896 11.2828 3.73429 11.2828H11.7616V7.21731C11.7616 6.95527 11.9075 6.71523 12.1415 6.58995C12.3755 6.46275 12.6614 6.47136 12.8875 6.61003L20.6573 11.3927C20.8708 11.5247 21 11.7533 21 12C21 12.2468 20.8708 12.4753 20.6573 12.6073L12.8875 17.39C12.7681 17.4627 12.632 17.5 12.4959 17.5C12.3745 17.5 12.2521 17.4694 12.1415 17.4101Z" fill="white"></path> </svg></div>
                    </div>
                </div>
                `);
            };


            // ReInit Swipers
            setTimeout(function () {
                gallerySwiperInit();
                gallerySwiperInit1();
            }, 150)

            // Скрытие кнопки
            if (dataAjax.offset + 2 > thisBtn.data('zals')) {
                thisBtn.hide();
            }



        }
    });
});

// Модалка О зале
$(document).on('click', '.halls__el-btn, .halls__el-img, .calculation__zal-left svg', function (e) {
    e.preventDefault();
    aboutZal.openModal();

    var aboutSliderWp = $('#about-zal .about-zal__slider-wrap'),
        aboutZalCont = $('#about-zal .sm-modal-contant');

    aboutZalCont.addClass('preloader');

    let dataAjax = {
        room_id: $(this).data('id'),
        _token: tokenData,
    }


    $.ajax({
        url: '/order/room',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;

            // console.log(result);
            // Очистка враппера слайдера
            aboutSliderWp.html('');

            console.log(result);
            // Вывод слайдов
            const sld = result;
            var slides = ``,
                slidesNum = sld.images.length;
            // Количество слайдов
            console.log(slidesNum);
            for (let index = 0; index < slidesNum; index++) {
                var galleruNum = index + 4,
                    galleryImg = sld.images[index],
                    slide = `<a class="about-zal__slider-el swiper-slide" href="${galleryImg}" data-fancybox="${galleruNum}">
                                    <img src="${galleryImg}" alt="">
                                </a>`;
                slides = slides + slide;
            }
            aboutSliderWp.append(slides)
            setTimeout(function () {
                aboutZalSlider.swiperVariable.update();
            }, 50);


            // Название зала
            var zalName = result.name,
                zalDescr = result.description;

            aboutZalCont.find('h4').text(zalName);
            aboutZalCont.find('.about-zal__content').html(zalDescr);

            // Убрать прелоадер
            $('#about-zal .sm-modal-contant').removeClass('preloader');


        }
    });
});


// Страница калькулятора


// Изменение количества гостей, переход с первого шага на второй

$(document).on('change', '.calculation__block-guest input', function (e) {

    // Получаем число из значения селекта
    var thisVal = Number($(this).val().replace(/\D+/g, "")),
        thisParent = $(this).parents('.calculation__block_step1');

    // Визуализация количества гостей
    thisParent.find('.calculation__block-head p b').text(thisVal);

    let dataAjax = {
        guest_count: thisVal,
        restaurant_id: $("#rest_id").val(),
        _token: tokenData,
    }

    $.ajax({
        url: '/search/rooms',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;

            // Очистка содержимого с залами
            $('.calculation__block-zals').html('');

            // console.log(result);

            // Вывод залов
            for (let index = 0; index < result.length; index++) {
                var zal = result[index],
                    zalImg = zal.image,
                    zalName = zal.name,
                    zalDescr = zal.description,
                    zalId = zal.id;

                $('.calculation__block-zals').append(`<label>
                    <input type="radio" name="room_id" value="${zalId}" hidden="">
                    <div class="calculation__zal">
                        <div class="calculation__zal-title">${zalName}</div>
                        <div class="checkbox__icon">
                            <svg width="15" height="12" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="calculation__zal-cont">
                            <div class="calculation__zal-left">
                                <img src="${zalImg}" alt="">
                                <svg width="24" height="24" data-id="${zalId}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 9H12V7.5C12 7.10218 11.842 6.72064 11.5607 6.43934C11.2794 6.15804 10.8978 6 10.5 6C10.1022 6 9.72064 6.15804 9.43934 6.43934C9.15804 6.72064 9 7.10218 9 7.5V9H7.5C7.10218 9 6.72064 9.15804 6.43934 9.43934C6.15804 9.72064 6 10.1022 6 10.5C6 10.8978 6.15804 11.2794 6.43934 11.5607C6.72064 11.842 7.10218 12 7.5 12H9V13.5C9 13.8978 9.15804 14.2794 9.43934 14.5607C9.72064 14.842 10.1022 15 10.5 15C10.8978 15 11.2794 14.842 11.5607 14.5607C11.842 14.2794 12 13.8978 12 13.5V12H13.5C13.8978 12 14.2794 11.842 14.5607 11.5607C14.842 11.2794 15 10.8978 15 10.5C15 10.1022 14.842 9.72064 14.5607 9.43934C14.2794 9.15804 13.8978 9 13.5 9Z" fill="white"></path>
                                    <path d="M23.561 21.4388L18.9 16.7768C20.4983 14.6425 21.2286 11.982 20.9441 9.33077C20.6595 6.67959 19.3811 4.23463 17.3663 2.48811C15.3515 0.741587 12.7499 -0.176819 10.0852 -0.0822231C7.42044 0.0123731 4.89048 1.11295 3.0046 2.99794C1.11871 4.88294 0.0169487 7.41238 -0.0789023 10.0771C-0.174753 12.7418 0.742428 15.3438 2.488 17.3595C4.23358 19.3751 6.67793 20.6546 9.32898 20.9404C11.98 21.2262 14.6409 20.4971 16.776 18.8998L21.439 23.5628C21.7204 23.8442 22.1021 24.0023 22.5 24.0023C22.898 24.0023 23.2796 23.8442 23.561 23.5628C23.8424 23.2814 24.0005 22.8998 24.0005 22.5018C24.0005 22.1039 23.8424 21.7222 23.561 21.4408V21.4388ZM10.5 17.9998C9.01664 17.9998 7.5666 17.56 6.33323 16.7359C5.09986 15.9118 4.13857 14.7404 3.57091 13.37C3.00325 11.9995 2.85473 10.4915 3.14412 9.03666C3.4335 7.5818 4.14781 6.24543 5.1967 5.19654C6.2456 4.14764 7.58197 3.43334 9.03683 3.14395C10.4917 2.85456 11.9997 3.00308 13.3701 3.57074C14.7406 4.1384 15.9119 5.09969 16.736 6.33306C17.5601 7.56643 18 9.01648 18 10.4998C17.9979 12.4883 17.207 14.3947 15.801 15.8008C14.3949 17.2069 12.4885 17.9977 10.5 17.9998Z" fill="white"></path>
                                </svg>
                            </div>
                            <div class="calculation__zal-right">
                                <div class="calculation__zal-text">
                                    ${zalDescr}
                                </div>
                                <a class="halls__el-btn btn" href="#" data-id="${zalId}">
                                    О зале
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.9833 6.26233L6.30639 3.58717C6.19532 3.48674 6.04988 3.43287 5.90019 3.43672C5.7505 3.44056 5.60802 3.50182 5.50224 3.60782C5.39647 3.71381 5.33552 3.85642 5.33199 4.00612C5.32846 4.15582 5.38264 4.30114 5.4833 4.412L8.15847 7.08717C8.26783 7.19656 8.32926 7.34491 8.32926 7.49958C8.32926 7.65426 8.26783 7.80261 8.15847 7.912L5.4833 10.5872C5.37392 10.6966 5.31251 10.845 5.31256 10.9998C5.31262 11.1545 5.37414 11.3029 5.4836 11.4123C5.59305 11.5217 5.74148 11.5831 5.89622 11.583C6.05096 11.583 6.19934 11.5215 6.30872 11.412L8.9833 8.73684C9.31138 8.40866 9.49568 7.96362 9.49568 7.49958C9.49568 7.03555 9.31138 6.59051 8.9833 6.26233Z" fill="white"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </label>`);
            }

            // Переход ко второму шагу

            var parBlock = $('.calculation__block_step1');
            var step2 = $('.calculation__block_step2');
            // Добавление класса, что с гостями можно редактировать
            parBlock.addClass('editable');

            setTimeout(function () {
                parBlock.find('.calculation__block-body').slideUp();
                step2.find('.calculation__block-body').slideDown();

                if (getCookie("redirectino") && getCookie("zal_id1") != undefined) {
                    $('.calculation__block_step2').find('input[value=' + getCookie("zal_id1") + ']').click();
                    $('.calculation__block_step2 .calculation__block-body').addClass('imdn');
                    setTimeout(function () {
                        $('.calculation__block_step2 .calculation__block-body').removeClass('imdn').hide();
                    }, 2000)
                }
            }, 50)

            setTimeout(function () {
                deleteCookie('guest_count1');
                deleteCookie('zal_id1');
                deleteCookie('redirectino');
                deleteCookie('date_val1');
            }, 200)
        }
    });
});

// Выбор зала и переход к следующему шагу (календарю)

// var particalRedDate = [];
// var redDate = [];

$(window).on('load', function () {


    $('.calendar__top').find('input').each(function () {

        console.log($(this).val());
    })

});

$(document).on('click change', '.calc-data__radio input,  .calculation__block-zals input, .calendar__top input', function (e) {

    var thisCheckName = $(this).siblings('.calculation__zal').find('.calculation__zal-title').text();
    var thisCheckNameCalend = $(this).siblings('label').find('p').text();
    var $this = $(this),
        thisRoom_id = $this.val();
    var selectedDate = replaceAlll($('#date_val').val(), '-', '/'),
        selectedDateObj = new Date(selectedDate),
        selectedDateResult = selectedDateObj.getFullYear() + '.' + selectedDateObj.getMonth() + '.' + selectedDateObj.getDate();
    // selectedDate.addClass('thisDay');


    if ($this.get(0).tagName == "LABEL") {
        thisRoom_id = $(this).find('input').val();
    }

    let dataAjax = {
        room_id: thisRoom_id,
        _token: tokenData,
    }

    // Скрываем нижнюю часть календаря при смене зала
    if ($('main').hasClass('clients')) {
        $('.calendar-wrapper').removeClass('broned-partical broned').addClass('empty');
    }

    // добавление осветление
    $('.calendar__broned, .applications, .calendar__empty, .custom-item, .calendar-mobile, .calendar').addClass('opac-block');

    // Обнуление массивов с датой
    particalRedDate = [];
    redDate = [];

    $.ajax({
        url: '/check/dates',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            // удаление осветление
            // setTimeout(function () { $('.calendar__broned, .applications, .calendar__empty, .custom-item').removeClass('opac-block'); }, 300)

            console.log($(document).find('#reserv-data'));
            if ($(document).find('#reserv-data').length > 0) {
                $('#reserv-data').find('.self__general-line.zal span').text(thisCheckNameCalend);
                $('#reserv-data').find('.self__general-line.zal').data('zal-id', $this.val());
            }

            if ($(document).find('#calc-main').length > 0) {
                $('#calc-main').find('.self__general-line.zal span').text(thisCheckNameCalend);
                $('#calc-main').find('.self__general-line.zal').data('zal-id', $this.val());
            }

            $('.calculation__block_step2 .zal-name').text(thisCheckName);

            // console.log(result);

            // добавление осветление
            $('.calendar__broned, .applications, .calendar__empty, .custom-item, .calendar-mobile, .calendar').removeClass('opac-block');

            for (let index = 0; index < result.length; index++) {
                const thisData = result[index],
                    thisDataOnly = replaceAlll(thisData.date.replace(' 00:00:00', ''), '-', '/'), //Выделение самой даты и замена - на ,
                    thisDataStatus = thisData.status; // Статус зала
                var currDate = new Date(thisDataOnly), // Разбивка полученной даты (чтоб сделать месяцы без нулей)
                    currMonth = currDate.getMonth(),
                    currYear = currDate.getFullYear(),
                    currDay = currDate.getDate(),
                    resultDate = currYear + '.' + currMonth + '.' + currDay; // Сборка даты
                // console.log(thisDataOnly);

                // console.log(thisDataOnly);
                // console.log(resultDate);

                // Создание массивов с датой
                if (!isNaN(currMonth) || !isNaN(currYear) || !isNaN(currDay)) {
                    if (thisDataStatus == 3) {
                        particalRedDate.push(resultDate);
                    } else if (thisDataStatus == 4) {
                        redDate.push(resultDate);
                    }
                }


            }

            if ($(window).width() > 767) {
                // Десктопный календарь - вывод дат
                if ($(document).find('.calendar').length > 0) {
                    $('.calendar').data('calendar').setCustomDayRenderer(
                        function (element, date) {
                            var thisStringDate = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();
                            for (var i = 0; i < redDate.length; i++) {
                                // console.log(redDate[i] + '==' + thisStringDate);
                                if (redDate[i] == thisStringDate) {
                                    $(element).parent().addClass('red');
                                }
                            }
                            for (var i = 0; i < particalRedDate.length; i++) {
                                if (particalRedDate[i] == thisStringDate) {
                                    $(element).parent().addClass('particalRed').append('<span class="dp-note"></span>');
                                }
                            }

                            // Выбор дня при смене зала
                            if (thisStringDate == selectedDateResult && $('#date_val').val().length > 0) {
                                setTimeout(function () {
                                    $(element).parent().click();
                                }, 100)
                            }

                            // Окра в серый прошедших дней
                            if (date.getMonth() < currentMounth && date.getFullYear() <= currentYear || date.getDate() < currentDay && date.getMonth() == currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) {
                                $(element).parent().addClass('grey-col');
                            }

                            if (getCookie('setDate') == undefined && getCookie('selectedZal') != undefined) {
                                if (thisStringDate == selDateJs) {
                                    console.log(element);
                                    $(element).parent().addClass('thisDate');
                                }
                            }
                        },
                    );
                }
            }

            // Мобильный календарь
            $('.calendar-mobile').datepicker({
                onRenderCell: function (date, cellType) {
                    var thisStringDate = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();
                    for (var i = 0; i < redDate.length; i++) {
                        if (redDate[i] == thisStringDate && cellType == 'day') {
                            return {
                                classes: 'red',
                            }
                        }
                    }
                    for (var i = 0; i < particalRedDate.length; i++) {
                        var currentDate = date.getDate();
                        if (particalRedDate[i] == thisStringDate && cellType == 'day') {
                            return {
                                html: currentDate + '<span class="dp-note"></span>',
                                classes: 'particalRed',
                            }
                        }
                    }

                    // Окрас в серый прошедших дней
                    if ((date.getMonth() < currentMounth && date.getFullYear() <= currentYear || date.getDate() < currentDay && date.getMonth() == currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'day') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                    // Окрас в серый прошедших месяцев
                    if ((date.getMonth() < currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'month') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                    // Окрас в серый прошедших лет
                    if ((date.getFullYear() < currentYear) && cellType == 'year') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                },
            });

            // Выбор дня при смене зала
            console.log($('#date_val').val());
            if ($(window).width() < 768 && $('#date_val').val().length > 0 && !$('main').hasClass('calculation')) {
                $('.calendar-mobile').datepicker().data('datepicker').selectDate(selectedDateObj);
            }




            // Мобильный календарь
            $('.calc-data__datapicker').datepicker({
                onRenderCell: function (date, cellType) {
                    var thisStringDate = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();
                    for (var i = 0; i < redDate.length; i++) {
                        if (redDate[i] == thisStringDate) {
                            return {
                                classes: 'red',
                            }
                        }
                    }
                    for (var i = 0; i < particalRedDate.length; i++) {
                        var currentDate = date.getDate();
                        if (particalRedDate[i] == thisStringDate) {
                            return {
                                html: currentDate + '<span class="dp-note"></span>',
                                classes: 'particalRed',
                            }
                        }
                    }

                    // Окрас в серый прошедших дней
                    if ((date.getMonth() < currentMounth && date.getFullYear() <= currentYear || date.getDate() < currentDay && date.getMonth() == currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'day') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                    // Окрас в серый прошедших месяцев
                    if ((date.getMonth() < currentMounth && date.getFullYear() == currentYear || date.getFullYear() < currentYear) && cellType == 'month') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                    // Окрас в серый прошедших лет
                    if ((date.getFullYear() < currentYear) && cellType == 'year') {
                        return {
                            classes: 'grey-col',
                        }
                    }
                },
            });


            // Переход к следующему шагу
            var parBlock = $('.calculation__block_step2');
            var step3 = $('.calculation__block_step3');
            // var step4 = $('.calculation__block_step4');

            parBlock.addClass('editable');

            setTimeout(function () {
                parBlock.find('.calculation__block-body').slideUp();
                step3.find('.calculation__block-body').slideDown();

                // $(document).find('.thisDay').click();
            }, 50)


            // Выбор даты при загрузке страницы с залом и датой в куки
            if (getCookie('selectedZal') != undefined) {
                if (!$('main').hasClass('calculation')) {
                    if ($(window).width() < 768) {
                        $('.calendar-mobile').datepicker().data('datepicker').selectDate(new Date(selDate));
                    } else {
                        $('.calendar').find('.thisDate').click();
                    }
                    deleteCookie('selectedZal');
                }
            }
        }
    });

});


// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//  Аякс при клике на дату в js календаря
// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////





// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// Переменная текущего айди
var currentOrderId = '';

// Кнопка подробнее в заявках календаря
$(document).on('click', '.applications__el-top-btn', function (e) {
    e.preventDefault();
    var thisId = $(this).data('id');
    $(this).parents('.booked__el, .applications__el').addClass('open-el');
    currentOrderId = thisId;

    renderDetailedModal(thisId);
});

// Модалка подробнее - её генерация
function renderDetailedModal(thisId) {

    var thisModal = $('#aboutClient');

    let dataAjax = {
        _token: tokenData,
    }

    thisModal.find('#order_id').val(thisId);

    $.ajax({
        url: '/order/info/' + thisId,
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            // Открываем модалку о клиенте
            aboutClient.openModal();

            // дата заявки
            thisModal.find('.order-data').text(result.created_at);
            // Источник
            thisModal.find('.order-source').text(result.source);
            thisModal.find('.order-source').data('source', result.source_id.id);

            // Имя
            thisModal.find('.modal-title .name').text(result.client_name);
            // Статус
            thisModal.find('.simple-select__item[data-num=' + result.status + ']').click();
            // Количество просмотров
            thisModal.find('.about-client__views-left span').text(result.view_count);
            // Количество гостей
            thisModal.find('.self__general-line.guest span').text(result.guest_count);
            // тип мероприятия
            thisModal.find('.self__general-line.type').data('type', result.type);
            switch (Number(result.type)) {
                case (1):
                    thisModal.find('.self__general-line.type span').text('Свадьба');
                    break
                case (2):
                    thisModal.find('.self__general-line.type span').text('Корпоратив');
                    break
                case (3):
                    thisModal.find('.self__general-line.type span').text('День рождения');
                    break
                case (4):
                    thisModal.find('.self__general-line.type span').text('Другое');
                    break
            }

            // Телефон
            thisModal.find('.self__general-line.phone span').text(result.phone);
            // Вотсап
            if (result.whatsapp == null) {
                thisModal.find('.self__general-line.whatsapp').hide();
            } else {
                thisModal.find('.self__general-line.whatsapp').show();
                thisModal.find('.self__general-line.whatsapp span').text(result.whatsapp);
            }
            //  email
            if (result.email == 'none') {
                thisModal.find('.self__general-line.mail span').text('—');
            } else {
                thisModal.find('.self__general-line.mail span').text(result.email);
            }

            //  Дата мероприятия

            if (result.reserve_date == undefined || result.reserve_date == "") {
                $('#aboutClient .self__general-line.date').hide();
            } else {
                var makeDate = replaceAlll(result.reserve_date, ' 00:00:00', '');
                var makeDateSplit = makeDate.split('-');
                $('#aboutClient .self__general-line.date').show();
                $('#aboutClient .self__general-line.date span').text(makeDateSplit[2] + '.' + makeDateSplit[1] + '.' + makeDateSplit[0]);
            }

            //  comment
            if (result.comment == null || result.comment == "") {
                thisModal.find('.about-client__comment').hide();
                thisModal.find('.about-client__comment').html('');
            } else {
                thisModal.find('.about-client__comment').show();
                thisModal.find('.about-client__comment').html(result.comment);
            }

            //  Кнопки телефона и вотсапа
            thisModal.find('.about-client__btns .btn-ph').attr('href', 'tel:' + result.phone);
            thisModal.find('.about-client__btns .btn-wa').attr('href', 'https://api.whatsapp.com/send?phone=' + result.whatsapp);
            //  Ссылка для клиента
            thisModal.find('.about-client__copy').attr('data-copy', result.order_link);


            // Приезжали ли на просмотр зала
            if (result.is_room_checked == 0) {
                $('.about-client__views-right').find('input[type=checkbox]').prop('checked', false);
            } else {
                $('.about-client__views-right').find('input[type=checkbox]').prop('checked', true);
            }


            // Очистка списка активных заявок
            $('.about-client__zaprosi .about-client__list').html('');

            // Вывод активных заявок в модалку
            if (result.active_inquiries.length > 0) {
                $('.about-client__zaprosi').show();

                for (let index = 0; index < result.active_inquiries.length; index++) {
                    const activeItem = result.active_inquiries[index];
                    var dateStatus = ``,
                        zalName = activeItem.room;

                    // Если зала нет
                    if (activeItem.room == null) {
                        zalName = '—'
                    }

                    var dateSepar = activeItem.date.split('-'),
                        dateSumm = dateSepar[2] + '.' + dateSepar[1] + '.' + dateSepar[0];

                    // Занятость зала
                    if (activeItem.is_busy_date == 0) {
                        var dateStatus = `<p>Дата: <span class="green">${dateSumm} - свободно </span></p>`;
                    } else if (activeItem.is_busy_date == 3) {
                        var dateStatus = `<p>Дата: <span class="red">${dateSumm} - частично занято </span></p>`;
                    } else {
                        var dateStatus = `<p>Дата: <span class="red">${dateSumm} - занято </span></p>`;
                    }



                    $('.about-client__zaprosi .about-client__list').append(`
                    <div class="check__contant">
                    <div class="label">Запрос от ${activeItem.created_at}</div>
                    <div class="check__contant-list">
                      <div class="check__contant-item check__contant-item_zal" data-zal-id=${activeItem.room_id}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8333 4.99908H11.9342C11.602 4.76234 11.2287 4.5894 10.8333 4.48908V4.16575L13.775 2.78908C13.8956 2.71434 13.9951 2.61006 14.0641 2.4861C14.1331 2.36214 14.1693 2.22262 14.1693 2.08075C14.1693 1.93887 14.1331 1.79935 14.0641 1.67539C13.9951 1.55143 13.8956 1.44715 13.775 1.37241L11.1083 0.122412C10.9001 0.0251222 10.6707 -0.0179906 10.4414 -0.00292445C10.2121 0.0121417 9.99028 0.0848986 9.79659 0.208593C9.6029 0.332287 9.4436 0.502909 9.33348 0.704621C9.22335 0.906333 9.16597 1.1326 9.16667 1.36241V4.48908C8.7715 4.58926 8.39846 4.76221 8.06667 4.99908H4.16667C3.062 5.0004 2.00296 5.43981 1.22185 6.22093C0.440735 7.00204 0.00132321 8.06108 0 9.16575L0 17.4991C0 18.1621 0.263392 18.798 0.732233 19.2668C1.20107 19.7357 1.83696 19.9991 2.5 19.9991H17.5C18.163 19.9991 18.7989 19.7357 19.2678 19.2668C19.7366 18.798 20 18.1621 20 17.4991V9.16575C19.9987 8.06108 19.5593 7.00204 18.7782 6.22093C17.997 5.43981 16.938 5.0004 15.8333 4.99908ZM18.18 8.33241H16.3808C15.7182 8.33072 15.0829 8.06748 14.6133 7.59991L13.6783 6.66575H15.8333C16.3486 6.66788 16.8505 6.82915 17.2706 7.12749C17.6906 7.42582 18.0083 7.84666 18.18 8.33241ZM4.16667 6.66575H6.32167L5.38667 7.59991C4.91706 8.06748 4.28184 8.33072 3.61917 8.33241H1.82C1.99174 7.84666 2.30936 7.42582 2.72942 7.12749C3.14948 6.82915 3.65145 6.66788 4.16667 6.66575ZM10.8333 18.3324H9.16667V15.8324C9.16667 15.6114 9.25446 15.3994 9.41074 15.2432C9.56702 15.0869 9.77899 14.9991 10 14.9991C10.221 14.9991 10.433 15.0869 10.5893 15.2432C10.7455 15.3994 10.8333 15.6114 10.8333 15.8324V18.3324ZM17.5 18.3324H12.5V15.8324C12.5 15.1694 12.2366 14.5335 11.7678 14.0646C11.2989 13.5958 10.663 13.3324 10 13.3324C9.33696 13.3324 8.70107 13.5958 8.23223 14.0646C7.76339 14.5335 7.5 15.1694 7.5 15.8324V18.3324H2.5C2.27899 18.3324 2.06702 18.2446 1.91074 18.0883C1.75446 17.9321 1.66667 17.7201 1.66667 17.4991V9.99908H3.61917C4.16651 10.0004 4.70869 9.89322 5.21434 9.68366C5.71999 9.47411 6.17906 9.16637 6.565 8.77824L8.82167 6.52241C9.13421 6.20996 9.55806 6.03443 10 6.03443C10.4419 6.03443 10.8658 6.20996 11.1783 6.52241L13.435 8.77824C13.8209 9.16637 14.28 9.47411 14.7857 9.68366C15.2913 9.89322 15.8335 10.0004 16.3808 9.99908H18.3333V17.4991C18.3333 17.7201 18.2455 17.9321 18.0893 18.0883C17.933 18.2446 17.721 18.3324 17.5 18.3324ZM5.83333 12.4991C5.83333 12.7201 5.74554 12.9321 5.58926 13.0883C5.43297 13.2446 5.22101 13.3324 5 13.3324H4.16667C3.94565 13.3324 3.73369 13.2446 3.57741 13.0883C3.42113 12.9321 3.33333 12.7201 3.33333 12.4991C3.33333 12.2781 3.42113 12.0661 3.57741 11.9098C3.73369 11.7535 3.94565 11.6657 4.16667 11.6657H5C5.22101 11.6657 5.43297 11.7535 5.58926 11.9098C5.74554 12.0661 5.83333 12.2781 5.83333 12.4991ZM5.83333 15.8324C5.83333 16.0534 5.74554 16.2654 5.58926 16.4217C5.43297 16.5779 5.22101 16.6657 5 16.6657H4.16667C3.94565 16.6657 3.73369 16.5779 3.57741 16.4217C3.42113 16.2654 3.33333 16.0534 3.33333 15.8324C3.33333 15.6114 3.42113 15.3994 3.57741 15.2432C3.73369 15.0869 3.94565 14.9991 4.16667 14.9991H5C5.22101 14.9991 5.43297 15.0869 5.58926 15.2432C5.74554 15.3994 5.83333 15.6114 5.83333 15.8324ZM16.6667 12.4991C16.6667 12.7201 16.5789 12.9321 16.4226 13.0883C16.2663 13.2446 16.0543 13.3324 15.8333 13.3324H15C14.779 13.3324 14.567 13.2446 14.4107 13.0883C14.2545 12.9321 14.1667 12.7201 14.1667 12.4991C14.1667 12.2781 14.2545 12.0661 14.4107 11.9098C14.567 11.7535 14.779 11.6657 15 11.6657H15.8333C16.0543 11.6657 16.2663 11.7535 16.4226 11.9098C16.5789 12.0661 16.6667 12.2781 16.6667 12.4991ZM16.6667 15.8324C16.6667 16.0534 16.5789 16.2654 16.4226 16.4217C16.2663 16.5779 16.0543 16.6657 15.8333 16.6657H15C14.779 16.6657 14.567 16.5779 14.4107 16.4217C14.2545 16.2654 14.1667 16.0534 14.1667 15.8324C14.1667 15.6114 14.2545 15.3994 14.4107 15.2432C14.567 15.0869 14.779 14.9991 15 14.9991H15.8333C16.0543 14.9991 16.2663 15.0869 16.4226 15.2432C16.5789 15.3994 16.6667 15.6114 16.6667 15.8324ZM11.6667 9.99908C11.6667 10.3287 11.5689 10.6509 11.3858 10.925C11.2026 11.1991 10.9423 11.4127 10.6378 11.5389C10.3333 11.665 9.99815 11.698 9.67485 11.6337C9.35155 11.5694 9.05458 11.4107 8.82149 11.1776C8.5884 10.9445 8.42967 10.6475 8.36536 10.3242C8.30105 10.0009 8.33405 9.66582 8.4602 9.36127C8.58635 9.05673 8.79997 8.79643 9.07405 8.6133C9.34813 8.43016 9.67036 8.33241 10 8.33241C10.442 8.33241 10.8659 8.50801 11.1785 8.82057C11.4911 9.13313 11.6667 9.55705 11.6667 9.99908Z" fill="#ABB2C7"></path>
                        </svg>
                        <p>Зал: <span>${zalName}</span></p>
                      </div>
                      <div class="check__contant-item check__contant-item_date" data-date="${dateSumm}">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z" fill="#ABB2C7"></path>
                            <path d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z" fill="#ABB2C7"></path>
                            <path d="M5.83398 13.75C6.52434 13.75 7.08398 13.1904 7.08398 12.5C7.08398 11.8096 6.52434 11.25 5.83398 11.25C5.14363 11.25 4.58398 11.8096 4.58398 12.5C4.58398 13.1904 5.14363 13.75 5.83398 13.75Z" fill="#ABB2C7"></path>
                            <path d="M14.166 13.75C14.8564 13.75 15.416 13.1904 15.416 12.5C15.416 11.8096 14.8564 11.25 14.166 11.25C13.4757 11.25 12.916 11.8096 12.916 12.5C12.916 13.1904 13.4757 13.75 14.166 13.75Z" fill="#ABB2C7"></path>
                        </svg>
                        ${dateStatus}
                        </div>
                        <div class="check__contant-item check__contant-item_guest">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.25 10.8333C5.50832 10.8333 4.7833 10.6134 4.16661 10.2013C3.54993 9.78929 3.06928 9.20362 2.78545 8.5184C2.50162 7.83318 2.42736 7.07918 2.57206 6.35175C2.71675 5.62432 3.0739 4.95613 3.59835 4.43168C4.1228 3.90724 4.79098 3.55008 5.51841 3.40539C6.24584 3.2607 6.99984 3.33496 7.68506 3.61879C8.37029 3.90262 8.95596 4.38326 9.36801 4.99995C9.78007 5.61663 10 6.34166 10 7.08334C9.9989 8.07756 9.60345 9.03075 8.90043 9.73377C8.19741 10.4368 7.24422 10.8322 6.25 10.8333ZM6.25 5C5.83796 5 5.43516 5.12219 5.09256 5.35111C4.74996 5.58003 4.48293 5.9054 4.32525 6.28608C4.16757 6.66676 4.12631 7.08565 4.2067 7.48977C4.28708 7.8939 4.4855 8.26511 4.77686 8.55647C5.06822 8.84783 5.43943 9.04625 5.84356 9.12664C6.24769 9.20702 6.66658 9.16577 7.04726 9.00808C7.42794 8.8504 7.75331 8.58338 7.98223 8.24077C8.21115 7.89817 8.33333 7.49538 8.33333 7.08334C8.33333 6.5308 8.11384 6.0009 7.72314 5.6102C7.33244 5.2195 6.80253 5 6.25 5ZM12.5 19.1667V18.75C12.5 17.0924 11.8415 15.5027 10.6694 14.3306C9.49731 13.1585 7.9076 12.5 6.25 12.5C4.5924 12.5 3.00268 13.1585 1.83058 14.3306C0.65848 15.5027 0 17.0924 0 18.75L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V18.75C1.66667 17.5344 2.14955 16.3686 3.00909 15.5091C3.86864 14.6496 5.03442 14.1667 6.25 14.1667C7.46558 14.1667 8.63136 14.6496 9.49091 15.5091C10.3504 16.3686 10.8333 17.5344 10.8333 18.75V19.1667C10.8333 19.3877 10.9211 19.5996 11.0774 19.7559C11.2337 19.9122 11.4457 20 11.6667 20C11.8877 20 12.0996 19.9122 12.2559 19.7559C12.4122 19.5996 12.5 19.3877 12.5 19.1667ZM20 15C20 13.8739 19.674 12.7719 19.0614 11.827C18.4489 10.8821 17.5759 10.1347 16.5479 9.67497C15.5199 9.21529 14.3808 9.06299 13.2681 9.23645C12.1555 9.40991 11.1168 9.90172 10.2775 10.6525C10.1948 10.7252 10.1273 10.8135 10.079 10.9124C10.0306 11.0113 10.0023 11.1188 9.99573 11.2287C9.98915 11.3386 10.0044 11.4487 10.0406 11.5526C10.0768 11.6566 10.1333 11.7523 10.2067 11.8343C10.2801 11.9164 10.3691 11.983 10.4684 12.0305C10.5678 12.0779 10.6755 12.1052 10.7855 12.1108C10.8954 12.1163 11.0054 12.1 11.109 12.0629C11.2126 12.0257 11.3078 11.9684 11.3892 11.8942C11.9887 11.358 12.7306 11.0069 13.5253 10.8831C14.3201 10.7593 15.1336 10.8681 15.8678 11.1965C16.6021 11.5249 17.2255 12.0588 17.663 12.7337C18.1005 13.4086 18.3333 14.1957 18.3333 15C18.3333 15.221 18.4211 15.433 18.5774 15.5893C18.7337 15.7455 18.9457 15.8333 19.1667 15.8333C19.3877 15.8333 19.5996 15.7455 19.7559 15.5893C19.9122 15.433 20 15.221 20 15ZM14.5833 7.5C13.8417 7.5 13.1166 7.28007 12.4999 6.86801C11.8833 6.45596 11.4026 5.87029 11.1188 5.18506C10.835 4.49984 10.7607 3.74584 10.9054 3.01841C11.0501 2.29098 11.4072 1.6228 11.9317 1.09835C12.4561 0.573904 13.1243 0.216751 13.8517 0.0720569C14.5792 -0.0726377 15.3332 0.00162482 16.0184 0.285453C16.7036 0.569282 17.2893 1.04993 17.7013 1.66661C18.1134 2.2833 18.3333 3.00832 18.3333 3.75C18.3322 4.74423 17.9368 5.69741 17.2338 6.40043C16.5307 7.10346 15.5776 7.4989 14.5833 7.5ZM14.5833 1.66667C14.1713 1.66667 13.7685 1.78885 13.4259 2.01777C13.0833 2.24669 12.8163 2.57207 12.6586 2.95274C12.5009 3.33342 12.4596 3.75231 12.54 4.15644C12.6204 4.56057 12.8188 4.93178 13.1102 5.22314C13.4016 5.5145 13.7728 5.71292 14.1769 5.7933C14.581 5.87369 14.9999 5.83243 15.3806 5.67475C15.7613 5.51707 16.0866 5.25004 16.3156 4.90744C16.5445 4.56484 16.6667 4.16205 16.6667 3.75C16.6667 3.19747 16.4472 2.66756 16.0565 2.27686C15.6658 1.88616 15.1359 1.66667 14.5833 1.66667Z" fill="#ABB2C7"></path>
                            </svg>
                            <p>Гостей: <span>${activeItem.guest_count}</span></p>
                        </div>
                    </div>
                        <div class="check__contant-btns"> <a class="btn calc_banket" href="#" data-id="${activeItem.id}">Рассчитать банкет</a>
                            <a class="btn btn_white to-archiv" href="#" data-id="${activeItem.id}">в Архив</a>
                        </div>
                  </div>
                `);
                }
            } else {
                $('.about-client__zaprosi').hide();
            }

            // Очистка списка обработанных заявок
            $('.about-client__obrabot .about-client__list').html('');

            // Вывод обработанных заявок в модалку
            if (result.archive_inquiries.length > 0) {
                $('.about-client__obrabot').show();

                for (let index = 0; index < result.archive_inquiries.length; index++) {
                    const archiveItem = result.archive_inquiries[index];

                    var zalName = archiveItem.room;

                    // Если зала нет
                    if (archiveItem.room == null) {
                        zalName = '—'
                    }

                    var dateSepar = archiveItem.date.split('-'),
                        dateSumm = dateSepar[2] + '.' + dateSepar[1] + '.' + dateSepar[0];

                    $('.about-client__obrabot .about-client__list').append(`
                    <div class="check__contant">
                        <div class="label">Запрос от ${archiveItem.created_at}</div>
                        <div class="check__contant-list">
                        <div class="check__contant-item check__contant-item_zal">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 4.99908H11.9342C11.602 4.76234 11.2287 4.5894 10.8333 4.48908V4.16575L13.775 2.78908C13.8956 2.71434 13.9951 2.61006 14.0641 2.4861C14.1331 2.36214 14.1693 2.22262 14.1693 2.08075C14.1693 1.93887 14.1331 1.79935 14.0641 1.67539C13.9951 1.55143 13.8956 1.44715 13.775 1.37241L11.1083 0.122412C10.9001 0.0251222 10.6707 -0.0179906 10.4414 -0.00292445C10.2121 0.0121417 9.99028 0.0848986 9.79659 0.208593C9.6029 0.332287 9.4436 0.502909 9.33348 0.704621C9.22335 0.906333 9.16597 1.1326 9.16667 1.36241V4.48908C8.7715 4.58926 8.39846 4.76221 8.06667 4.99908H4.16667C3.062 5.0004 2.00296 5.43981 1.22185 6.22093C0.440735 7.00204 0.00132321 8.06108 0 9.16575L0 17.4991C0 18.1621 0.263392 18.798 0.732233 19.2668C1.20107 19.7357 1.83696 19.9991 2.5 19.9991H17.5C18.163 19.9991 18.7989 19.7357 19.2678 19.2668C19.7366 18.798 20 18.1621 20 17.4991V9.16575C19.9987 8.06108 19.5593 7.00204 18.7782 6.22093C17.997 5.43981 16.938 5.0004 15.8333 4.99908ZM18.18 8.33241H16.3808C15.7182 8.33072 15.0829 8.06748 14.6133 7.59991L13.6783 6.66575H15.8333C16.3486 6.66788 16.8505 6.82915 17.2706 7.12749C17.6906 7.42582 18.0083 7.84666 18.18 8.33241ZM4.16667 6.66575H6.32167L5.38667 7.59991C4.91706 8.06748 4.28184 8.33072 3.61917 8.33241H1.82C1.99174 7.84666 2.30936 7.42582 2.72942 7.12749C3.14948 6.82915 3.65145 6.66788 4.16667 6.66575ZM10.8333 18.3324H9.16667V15.8324C9.16667 15.6114 9.25446 15.3994 9.41074 15.2432C9.56702 15.0869 9.77899 14.9991 10 14.9991C10.221 14.9991 10.433 15.0869 10.5893 15.2432C10.7455 15.3994 10.8333 15.6114 10.8333 15.8324V18.3324ZM17.5 18.3324H12.5V15.8324C12.5 15.1694 12.2366 14.5335 11.7678 14.0646C11.2989 13.5958 10.663 13.3324 10 13.3324C9.33696 13.3324 8.70107 13.5958 8.23223 14.0646C7.76339 14.5335 7.5 15.1694 7.5 15.8324V18.3324H2.5C2.27899 18.3324 2.06702 18.2446 1.91074 18.0883C1.75446 17.9321 1.66667 17.7201 1.66667 17.4991V9.99908H3.61917C4.16651 10.0004 4.70869 9.89322 5.21434 9.68366C5.71999 9.47411 6.17906 9.16637 6.565 8.77824L8.82167 6.52241C9.13421 6.20996 9.55806 6.03443 10 6.03443C10.4419 6.03443 10.8658 6.20996 11.1783 6.52241L13.435 8.77824C13.8209 9.16637 14.28 9.47411 14.7857 9.68366C15.2913 9.89322 15.8335 10.0004 16.3808 9.99908H18.3333V17.4991C18.3333 17.7201 18.2455 17.9321 18.0893 18.0883C17.933 18.2446 17.721 18.3324 17.5 18.3324ZM5.83333 12.4991C5.83333 12.7201 5.74554 12.9321 5.58926 13.0883C5.43297 13.2446 5.22101 13.3324 5 13.3324H4.16667C3.94565 13.3324 3.73369 13.2446 3.57741 13.0883C3.42113 12.9321 3.33333 12.7201 3.33333 12.4991C3.33333 12.2781 3.42113 12.0661 3.57741 11.9098C3.73369 11.7535 3.94565 11.6657 4.16667 11.6657H5C5.22101 11.6657 5.43297 11.7535 5.58926 11.9098C5.74554 12.0661 5.83333 12.2781 5.83333 12.4991ZM5.83333 15.8324C5.83333 16.0534 5.74554 16.2654 5.58926 16.4217C5.43297 16.5779 5.22101 16.6657 5 16.6657H4.16667C3.94565 16.6657 3.73369 16.5779 3.57741 16.4217C3.42113 16.2654 3.33333 16.0534 3.33333 15.8324C3.33333 15.6114 3.42113 15.3994 3.57741 15.2432C3.73369 15.0869 3.94565 14.9991 4.16667 14.9991H5C5.22101 14.9991 5.43297 15.0869 5.58926 15.2432C5.74554 15.3994 5.83333 15.6114 5.83333 15.8324ZM16.6667 12.4991C16.6667 12.7201 16.5789 12.9321 16.4226 13.0883C16.2663 13.2446 16.0543 13.3324 15.8333 13.3324H15C14.779 13.3324 14.567 13.2446 14.4107 13.0883C14.2545 12.9321 14.1667 12.7201 14.1667 12.4991C14.1667 12.2781 14.2545 12.0661 14.4107 11.9098C14.567 11.7535 14.779 11.6657 15 11.6657H15.8333C16.0543 11.6657 16.2663 11.7535 16.4226 11.9098C16.5789 12.0661 16.6667 12.2781 16.6667 12.4991ZM16.6667 15.8324C16.6667 16.0534 16.5789 16.2654 16.4226 16.4217C16.2663 16.5779 16.0543 16.6657 15.8333 16.6657H15C14.779 16.6657 14.567 16.5779 14.4107 16.4217C14.2545 16.2654 14.1667 16.0534 14.1667 15.8324C14.1667 15.6114 14.2545 15.3994 14.4107 15.2432C14.567 15.0869 14.779 14.9991 15 14.9991H15.8333C16.0543 14.9991 16.2663 15.0869 16.4226 15.2432C16.5789 15.3994 16.6667 15.6114 16.6667 15.8324ZM11.6667 9.99908C11.6667 10.3287 11.5689 10.6509 11.3858 10.925C11.2026 11.1991 10.9423 11.4127 10.6378 11.5389C10.3333 11.665 9.99815 11.698 9.67485 11.6337C9.35155 11.5694 9.05458 11.4107 8.82149 11.1776C8.5884 10.9445 8.42967 10.6475 8.36536 10.3242C8.30105 10.0009 8.33405 9.66582 8.4602 9.36127C8.58635 9.05673 8.79997 8.79643 9.07405 8.6133C9.34813 8.43016 9.67036 8.33241 10 8.33241C10.442 8.33241 10.8659 8.50801 11.1785 8.82057C11.4911 9.13313 11.6667 9.55705 11.6667 9.99908Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Зал: <span>${zalName}</span></p>
                        </div>
                        <div class="check__contant-item check__contant-item_date" data-date="${archiveItem.date}">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z" fill="#ABB2C7"></path>
                                    <path d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M5.83398 13.75C6.52434 13.75 7.08398 13.1904 7.08398 12.5C7.08398 11.8096 6.52434 11.25 5.83398 11.25C5.14363 11.25 4.58398 11.8096 4.58398 12.5C4.58398 13.1904 5.14363 13.75 5.83398 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M14.166 13.75C14.8564 13.75 15.416 13.1904 15.416 12.5C15.416 11.8096 14.8564 11.25 14.166 11.25C13.4757 11.25 12.916 11.8096 12.916 12.5C12.916 13.1904 13.4757 13.75 14.166 13.75Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Дата: <span>${dateSumm}</span></p>
                        </div>
                        <div class="check__contant-item check__contant-item_guset">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 10.8333C5.50832 10.8333 4.7833 10.6134 4.16661 10.2013C3.54993 9.78929 3.06928 9.20362 2.78545 8.5184C2.50162 7.83318 2.42736 7.07918 2.57206 6.35175C2.71675 5.62432 3.0739 4.95613 3.59835 4.43168C4.1228 3.90724 4.79098 3.55008 5.51841 3.40539C6.24584 3.2607 6.99984 3.33496 7.68506 3.61879C8.37029 3.90262 8.95596 4.38326 9.36801 4.99995C9.78007 5.61663 10 6.34166 10 7.08334C9.9989 8.07756 9.60345 9.03075 8.90043 9.73377C8.19741 10.4368 7.24422 10.8322 6.25 10.8333ZM6.25 5C5.83796 5 5.43516 5.12219 5.09256 5.35111C4.74996 5.58003 4.48293 5.9054 4.32525 6.28608C4.16757 6.66676 4.12631 7.08565 4.2067 7.48977C4.28708 7.8939 4.4855 8.26511 4.77686 8.55647C5.06822 8.84783 5.43943 9.04625 5.84356 9.12664C6.24769 9.20702 6.66658 9.16577 7.04726 9.00808C7.42794 8.8504 7.75331 8.58338 7.98223 8.24077C8.21115 7.89817 8.33333 7.49538 8.33333 7.08334C8.33333 6.5308 8.11384 6.0009 7.72314 5.6102C7.33244 5.2195 6.80253 5 6.25 5ZM12.5 19.1667V18.75C12.5 17.0924 11.8415 15.5027 10.6694 14.3306C9.49731 13.1585 7.9076 12.5 6.25 12.5C4.5924 12.5 3.00268 13.1585 1.83058 14.3306C0.65848 15.5027 0 17.0924 0 18.75L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V18.75C1.66667 17.5344 2.14955 16.3686 3.00909 15.5091C3.86864 14.6496 5.03442 14.1667 6.25 14.1667C7.46558 14.1667 8.63136 14.6496 9.49091 15.5091C10.3504 16.3686 10.8333 17.5344 10.8333 18.75V19.1667C10.8333 19.3877 10.9211 19.5996 11.0774 19.7559C11.2337 19.9122 11.4457 20 11.6667 20C11.8877 20 12.0996 19.9122 12.2559 19.7559C12.4122 19.5996 12.5 19.3877 12.5 19.1667ZM20 15C20 13.8739 19.674 12.7719 19.0614 11.827C18.4489 10.8821 17.5759 10.1347 16.5479 9.67497C15.5199 9.21529 14.3808 9.06299 13.2681 9.23645C12.1555 9.40991 11.1168 9.90172 10.2775 10.6525C10.1948 10.7252 10.1273 10.8135 10.079 10.9124C10.0306 11.0113 10.0023 11.1188 9.99573 11.2287C9.98915 11.3386 10.0044 11.4487 10.0406 11.5526C10.0768 11.6566 10.1333 11.7523 10.2067 11.8343C10.2801 11.9164 10.3691 11.983 10.4684 12.0305C10.5678 12.0779 10.6755 12.1052 10.7855 12.1108C10.8954 12.1163 11.0054 12.1 11.109 12.0629C11.2126 12.0257 11.3078 11.9684 11.3892 11.8942C11.9887 11.358 12.7306 11.0069 13.5253 10.8831C14.3201 10.7593 15.1336 10.8681 15.8678 11.1965C16.6021 11.5249 17.2255 12.0588 17.663 12.7337C18.1005 13.4086 18.3333 14.1957 18.3333 15C18.3333 15.221 18.4211 15.433 18.5774 15.5893C18.7337 15.7455 18.9457 15.8333 19.1667 15.8333C19.3877 15.8333 19.5996 15.7455 19.7559 15.5893C19.9122 15.433 20 15.221 20 15ZM14.5833 7.5C13.8417 7.5 13.1166 7.28007 12.4999 6.86801C11.8833 6.45596 11.4026 5.87029 11.1188 5.18506C10.835 4.49984 10.7607 3.74584 10.9054 3.01841C11.0501 2.29098 11.4072 1.6228 11.9317 1.09835C12.4561 0.573904 13.1243 0.216751 13.8517 0.0720569C14.5792 -0.0726377 15.3332 0.00162482 16.0184 0.285453C16.7036 0.569282 17.2893 1.04993 17.7013 1.66661C18.1134 2.2833 18.3333 3.00832 18.3333 3.75C18.3322 4.74423 17.9368 5.69741 17.2338 6.40043C16.5307 7.10346 15.5776 7.4989 14.5833 7.5ZM14.5833 1.66667C14.1713 1.66667 13.7685 1.78885 13.4259 2.01777C13.0833 2.24669 12.8163 2.57207 12.6586 2.95274C12.5009 3.33342 12.4596 3.75231 12.54 4.15644C12.6204 4.56057 12.8188 4.93178 13.1102 5.22314C13.4016 5.5145 13.7728 5.71292 14.1769 5.7933C14.581 5.87369 14.9999 5.83243 15.3806 5.67475C15.7613 5.51707 16.0866 5.25004 16.3156 4.90744C16.5445 4.56484 16.6667 4.16205 16.6667 3.75C16.6667 3.19747 16.4472 2.66756 16.0565 2.27686C15.6658 1.88616 15.1359 1.66667 14.5833 1.66667Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Гостей: <span>${archiveItem.guest_count}</span></p>
                        </div>
                        </div>
                    </div>
                    `);

                }
            } else {
                $('.about-client__obrabot').hide();
            }

            // Очистка списка отправленных расчетов
            $('.about-client__raschet .about-client__list').html('');

            // Вывод отправленных расчетов в модалку
            if (result.options.length > 0) {
                $('.about-client__raschet').show();
                for (let index = 0; index < result.options.length; index++) {
                    const raschetItem = result.options[index];
                    var zalName = raschetItem.room,
                        eatWeight = raschetItem.amount;

                    // Выделение КГ и Грамм если больше 1000 грамм
                    if (eatWeight < 1001) {
                        var eatWeightWrite = `<span>${eatWeight} гр./чел.</span>`
                    } else {
                        // Превращение с троку иначе длинна не считается
                        var eStart = eatWeight.toString().length - 3,
                            eEnd = eatWeight.toString().length,
                            eatWeightGramm = eatWeight.toString().slice(eStart, eEnd),
                            eatWeightKg = (eatWeight / 1000).toString().split(".")[0];
                        var eatWeightWrite = `<span> ${eatWeightKg} кг. ${eatWeightGramm} гр./чел.</span>`
                    }

                    // Если зала нет
                    if (raschetItem.room == null) {
                        zalName = '—'
                    }

                    var dateSepar = raschetItem.date.split('-'),
                        dateSumm = dateSepar[2] + '.' + dateSepar[1] + '.' + dateSepar[0];


                    $('.about-client__raschet .about-client__list').append(`
                        <div class="check__contant">
                            <div class="label">${raschetItem.name} от ${raschetItem.created_at}</div>
                            <div class="check__contant-top">
                            <p>${triplets(raschetItem.cost)}₽</p>${eatWeightWrite}
                            </div>
                            <div class="check__contant-list">
                            <div class="check__contant-item check__contant-item_zal">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 4.99908H11.9342C11.602 4.76234 11.2287 4.5894 10.8333 4.48908V4.16575L13.775 2.78908C13.8956 2.71434 13.9951 2.61006 14.0641 2.4861C14.1331 2.36214 14.1693 2.22262 14.1693 2.08075C14.1693 1.93887 14.1331 1.79935 14.0641 1.67539C13.9951 1.55143 13.8956 1.44715 13.775 1.37241L11.1083 0.122412C10.9001 0.0251222 10.6707 -0.0179906 10.4414 -0.00292445C10.2121 0.0121417 9.99028 0.0848986 9.79659 0.208593C9.6029 0.332287 9.4436 0.502909 9.33348 0.704621C9.22335 0.906333 9.16597 1.1326 9.16667 1.36241V4.48908C8.7715 4.58926 8.39846 4.76221 8.06667 4.99908H4.16667C3.062 5.0004 2.00296 5.43981 1.22185 6.22093C0.440735 7.00204 0.00132321 8.06108 0 9.16575L0 17.4991C0 18.1621 0.263392 18.798 0.732233 19.2668C1.20107 19.7357 1.83696 19.9991 2.5 19.9991H17.5C18.163 19.9991 18.7989 19.7357 19.2678 19.2668C19.7366 18.798 20 18.1621 20 17.4991V9.16575C19.9987 8.06108 19.5593 7.00204 18.7782 6.22093C17.997 5.43981 16.938 5.0004 15.8333 4.99908ZM18.18 8.33241H16.3808C15.7182 8.33072 15.0829 8.06748 14.6133 7.59991L13.6783 6.66575H15.8333C16.3486 6.66788 16.8505 6.82915 17.2706 7.12749C17.6906 7.42582 18.0083 7.84666 18.18 8.33241ZM4.16667 6.66575H6.32167L5.38667 7.59991C4.91706 8.06748 4.28184 8.33072 3.61917 8.33241H1.82C1.99174 7.84666 2.30936 7.42582 2.72942 7.12749C3.14948 6.82915 3.65145 6.66788 4.16667 6.66575ZM10.8333 18.3324H9.16667V15.8324C9.16667 15.6114 9.25446 15.3994 9.41074 15.2432C9.56702 15.0869 9.77899 14.9991 10 14.9991C10.221 14.9991 10.433 15.0869 10.5893 15.2432C10.7455 15.3994 10.8333 15.6114 10.8333 15.8324V18.3324ZM17.5 18.3324H12.5V15.8324C12.5 15.1694 12.2366 14.5335 11.7678 14.0646C11.2989 13.5958 10.663 13.3324 10 13.3324C9.33696 13.3324 8.70107 13.5958 8.23223 14.0646C7.76339 14.5335 7.5 15.1694 7.5 15.8324V18.3324H2.5C2.27899 18.3324 2.06702 18.2446 1.91074 18.0883C1.75446 17.9321 1.66667 17.7201 1.66667 17.4991V9.99908H3.61917C4.16651 10.0004 4.70869 9.89322 5.21434 9.68366C5.71999 9.47411 6.17906 9.16637 6.565 8.77824L8.82167 6.52241C9.13421 6.20996 9.55806 6.03443 10 6.03443C10.4419 6.03443 10.8658 6.20996 11.1783 6.52241L13.435 8.77824C13.8209 9.16637 14.28 9.47411 14.7857 9.68366C15.2913 9.89322 15.8335 10.0004 16.3808 9.99908H18.3333V17.4991C18.3333 17.7201 18.2455 17.9321 18.0893 18.0883C17.933 18.2446 17.721 18.3324 17.5 18.3324ZM5.83333 12.4991C5.83333 12.7201 5.74554 12.9321 5.58926 13.0883C5.43297 13.2446 5.22101 13.3324 5 13.3324H4.16667C3.94565 13.3324 3.73369 13.2446 3.57741 13.0883C3.42113 12.9321 3.33333 12.7201 3.33333 12.4991C3.33333 12.2781 3.42113 12.0661 3.57741 11.9098C3.73369 11.7535 3.94565 11.6657 4.16667 11.6657H5C5.22101 11.6657 5.43297 11.7535 5.58926 11.9098C5.74554 12.0661 5.83333 12.2781 5.83333 12.4991ZM5.83333 15.8324C5.83333 16.0534 5.74554 16.2654 5.58926 16.4217C5.43297 16.5779 5.22101 16.6657 5 16.6657H4.16667C3.94565 16.6657 3.73369 16.5779 3.57741 16.4217C3.42113 16.2654 3.33333 16.0534 3.33333 15.8324C3.33333 15.6114 3.42113 15.3994 3.57741 15.2432C3.73369 15.0869 3.94565 14.9991 4.16667 14.9991H5C5.22101 14.9991 5.43297 15.0869 5.58926 15.2432C5.74554 15.3994 5.83333 15.6114 5.83333 15.8324ZM16.6667 12.4991C16.6667 12.7201 16.5789 12.9321 16.4226 13.0883C16.2663 13.2446 16.0543 13.3324 15.8333 13.3324H15C14.779 13.3324 14.567 13.2446 14.4107 13.0883C14.2545 12.9321 14.1667 12.7201 14.1667 12.4991C14.1667 12.2781 14.2545 12.0661 14.4107 11.9098C14.567 11.7535 14.779 11.6657 15 11.6657H15.8333C16.0543 11.6657 16.2663 11.7535 16.4226 11.9098C16.5789 12.0661 16.6667 12.2781 16.6667 12.4991ZM16.6667 15.8324C16.6667 16.0534 16.5789 16.2654 16.4226 16.4217C16.2663 16.5779 16.0543 16.6657 15.8333 16.6657H15C14.779 16.6657 14.567 16.5779 14.4107 16.4217C14.2545 16.2654 14.1667 16.0534 14.1667 15.8324C14.1667 15.6114 14.2545 15.3994 14.4107 15.2432C14.567 15.0869 14.779 14.9991 15 14.9991H15.8333C16.0543 14.9991 16.2663 15.0869 16.4226 15.2432C16.5789 15.3994 16.6667 15.6114 16.6667 15.8324ZM11.6667 9.99908C11.6667 10.3287 11.5689 10.6509 11.3858 10.925C11.2026 11.1991 10.9423 11.4127 10.6378 11.5389C10.3333 11.665 9.99815 11.698 9.67485 11.6337C9.35155 11.5694 9.05458 11.4107 8.82149 11.1776C8.5884 10.9445 8.42967 10.6475 8.36536 10.3242C8.30105 10.0009 8.33405 9.66582 8.4602 9.36127C8.58635 9.05673 8.79997 8.79643 9.07405 8.6133C9.34813 8.43016 9.67036 8.33241 10 8.33241C10.442 8.33241 10.8659 8.50801 11.1785 8.82057C11.4911 9.13313 11.6667 9.55705 11.6667 9.99908Z" fill="#ABB2C7"></path>
                                </svg>
                                <p>Зал: <span>${zalName}</span></p>
                            </div>
                            <div class="check__contant-item check__contant-item_date" data-date="${raschetItem.date}">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z" fill="#ABB2C7"></path>
                                    <path d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M5.83398 13.75C6.52434 13.75 7.08398 13.1904 7.08398 12.5C7.08398 11.8096 6.52434 11.25 5.83398 11.25C5.14363 11.25 4.58398 11.8096 4.58398 12.5C4.58398 13.1904 5.14363 13.75 5.83398 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M14.166 13.75C14.8564 13.75 15.416 13.1904 15.416 12.5C15.416 11.8096 14.8564 11.25 14.166 11.25C13.4757 11.25 12.916 11.8096 12.916 12.5C12.916 13.1904 13.4757 13.75 14.166 13.75Z" fill="#ABB2C7"></path>
                                </svg>
                                <p>Дата: <span>${dateSumm}</span></p>
                            </div>
                            <div class="check__contant-item check__contant-item_guest">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 10.8333C5.50832 10.8333 4.7833 10.6134 4.16661 10.2013C3.54993 9.78929 3.06928 9.20362 2.78545 8.5184C2.50162 7.83318 2.42736 7.07918 2.57206 6.35175C2.71675 5.62432 3.0739 4.95613 3.59835 4.43168C4.1228 3.90724 4.79098 3.55008 5.51841 3.40539C6.24584 3.2607 6.99984 3.33496 7.68506 3.61879C8.37029 3.90262 8.95596 4.38326 9.36801 4.99995C9.78007 5.61663 10 6.34166 10 7.08334C9.9989 8.07756 9.60345 9.03075 8.90043 9.73377C8.19741 10.4368 7.24422 10.8322 6.25 10.8333ZM6.25 5C5.83796 5 5.43516 5.12219 5.09256 5.35111C4.74996 5.58003 4.48293 5.9054 4.32525 6.28608C4.16757 6.66676 4.12631 7.08565 4.2067 7.48977C4.28708 7.8939 4.4855 8.26511 4.77686 8.55647C5.06822 8.84783 5.43943 9.04625 5.84356 9.12664C6.24769 9.20702 6.66658 9.16577 7.04726 9.00808C7.42794 8.8504 7.75331 8.58338 7.98223 8.24077C8.21115 7.89817 8.33333 7.49538 8.33333 7.08334C8.33333 6.5308 8.11384 6.0009 7.72314 5.6102C7.33244 5.2195 6.80253 5 6.25 5ZM12.5 19.1667V18.75C12.5 17.0924 11.8415 15.5027 10.6694 14.3306C9.49731 13.1585 7.9076 12.5 6.25 12.5C4.5924 12.5 3.00268 13.1585 1.83058 14.3306C0.65848 15.5027 0 17.0924 0 18.75L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V18.75C1.66667 17.5344 2.14955 16.3686 3.00909 15.5091C3.86864 14.6496 5.03442 14.1667 6.25 14.1667C7.46558 14.1667 8.63136 14.6496 9.49091 15.5091C10.3504 16.3686 10.8333 17.5344 10.8333 18.75V19.1667C10.8333 19.3877 10.9211 19.5996 11.0774 19.7559C11.2337 19.9122 11.4457 20 11.6667 20C11.8877 20 12.0996 19.9122 12.2559 19.7559C12.4122 19.5996 12.5 19.3877 12.5 19.1667ZM20 15C20 13.8739 19.674 12.7719 19.0614 11.827C18.4489 10.8821 17.5759 10.1347 16.5479 9.67497C15.5199 9.21529 14.3808 9.06299 13.2681 9.23645C12.1555 9.40991 11.1168 9.90172 10.2775 10.6525C10.1948 10.7252 10.1273 10.8135 10.079 10.9124C10.0306 11.0113 10.0023 11.1188 9.99573 11.2287C9.98915 11.3386 10.0044 11.4487 10.0406 11.5526C10.0768 11.6566 10.1333 11.7523 10.2067 11.8343C10.2801 11.9164 10.3691 11.983 10.4684 12.0305C10.5678 12.0779 10.6755 12.1052 10.7855 12.1108C10.8954 12.1163 11.0054 12.1 11.109 12.0629C11.2126 12.0257 11.3078 11.9684 11.3892 11.8942C11.9887 11.358 12.7306 11.0069 13.5253 10.8831C14.3201 10.7593 15.1336 10.8681 15.8678 11.1965C16.6021 11.5249 17.2255 12.0588 17.663 12.7337C18.1005 13.4086 18.3333 14.1957 18.3333 15C18.3333 15.221 18.4211 15.433 18.5774 15.5893C18.7337 15.7455 18.9457 15.8333 19.1667 15.8333C19.3877 15.8333 19.5996 15.7455 19.7559 15.5893C19.9122 15.433 20 15.221 20 15ZM14.5833 7.5C13.8417 7.5 13.1166 7.28007 12.4999 6.86801C11.8833 6.45596 11.4026 5.87029 11.1188 5.18506C10.835 4.49984 10.7607 3.74584 10.9054 3.01841C11.0501 2.29098 11.4072 1.6228 11.9317 1.09835C12.4561 0.573904 13.1243 0.216751 13.8517 0.0720569C14.5792 -0.0726377 15.3332 0.00162482 16.0184 0.285453C16.7036 0.569282 17.2893 1.04993 17.7013 1.66661C18.1134 2.2833 18.3333 3.00832 18.3333 3.75C18.3322 4.74423 17.9368 5.69741 17.2338 6.40043C16.5307 7.10346 15.5776 7.4989 14.5833 7.5ZM14.5833 1.66667C14.1713 1.66667 13.7685 1.78885 13.4259 2.01777C13.0833 2.24669 12.8163 2.57207 12.6586 2.95274C12.5009 3.33342 12.4596 3.75231 12.54 4.15644C12.6204 4.56057 12.8188 4.93178 13.1102 5.22314C13.4016 5.5145 13.7728 5.71292 14.1769 5.7933C14.581 5.87369 14.9999 5.83243 15.3806 5.67475C15.7613 5.51707 16.0866 5.25004 16.3156 4.90744C16.5445 4.56484 16.6667 4.16205 16.6667 3.75C16.6667 3.19747 16.4472 2.66756 16.0565 2.27686C15.6658 1.88616 15.1359 1.66667 14.5833 1.66667Z" fill="#ABB2C7"></path>
                                </svg>
                                <p>Гостей: <span>${raschetItem.guest_count}</span></p>
                            </div>
                            </div><a href="${raschetItem.view_link}" data-id="${raschetItem.id}">Посмотреть меню и условия</a>
                        </div>
                    `);
                }
            } else {
                $('.about-client__raschet').hide();
            }



        }
    });
}




// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Модалка Бронь даты

$('.reserv-data__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);
    var inpBl = $this.find('.input-block:not(.input-block_comment)'),
        thisModal = $('#reserv-data')
    // var inp = $(this).find('input').val().length;

    //  Типа валидация ////////////////////
    inpBl.each(function () {
        var thisInp = $(this).find('input, textarea');
        if (thisInp.val().length > 2) {
            thisInp.parents('.input-block').removeClass('wrong');
        } else {
            thisInp.parents('.input-block').addClass('wrong');
        }
    });

    thisModal.find('.simple-select').each(function () {
        var thisInp = $(this).find('input'),
            $thiss = $(this);
        if (thisInp.val().length == 0) {
            $thiss.addClass('wrong');
        } else {
            $thiss.removeClass('wrong');
        }

    })

    ////////////////////////////

    //
    // reserv.openModal();
    // reservData.closeModal();
    //

    if ($this.find('.wrong').length == 0) {
        console.log('sub');
        // reserv.openModal();
        // reservData.closeModal();

        let roomId = $('.calendar__top').find('input:checked').val();
        if ($('main').hasClass('clients')) {
            // roomId =
        }

        let dataAjax = {
            guest_count: thisModal.find('#reserv_data_guest').val(),
            date: $('#date_val').val(),
            room_id: roomId,
            name: thisModal.find('.name input').val(),
            phone: thisModal.find('.phone input').val(),
            event_type_id: thisModal.find('#reserv_data_type').val(),
            status: thisModal.find('#reserv_data_status').val(),
            comment: thisModal.find('.input-block textarea').val(),
            source_id: 1,
            _token: tokenData,
        }

        console.log($('#aboutClient').hasClass('active'));

        if ($('#aboutClient').hasClass('active')) {
            dataAjax['id'] = $('#order_id').val();
        }

        console.log(dataAjax);

        $.ajax({
            url: '/order/store',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                if (result != "CLOSED_DATE") {
                    $this[0].reset();
                    console.log(result);
                    reserv.openModal();
                    reservData.closeModal();

                    // Сброс инпутов и селектов при сбросе формы
                    inpBl.removeClass('noempty').find('input').val('');
                    resetSelect($this.find('.simple-select'));

                    // Визуализация смены статуса при брони
                    if ($('#aboutClient').hasClass('active')) {
                        $('#aboutClient .about-client__order-type .simple-select__item').removeClass('nochange');
                        $('#aboutClient .about-client__order-type').find('.simple-select__item[data-value="3"]').addClass('noopen');
                        $('#aboutClient .about-client__order-type').find('.simple-select__item[data-value="4"]').addClass('noopen');
                        setTimeout(function () {
                            $('#aboutClient .about-client__order-type .simple-select__item[data-value=' + dataAjax.status + ']').click();
                        }, 50)
                        setTimeout(function () {
                            $('#aboutClient .about-client__order-type .simple-select__item[data-value="3"]').addClass('nochange');
                            $('#aboutClient .about-client__order-type .simple-select__item[data-value="4"]').addClass('nochange');
                            $('#aboutClient .about-client__order-type').find('.simple-select__item[data-value="3"]').removeClass('noopen');
                            $('#aboutClient .about-client__order-type').find('.simple-select__item[data-value="4"]').removeClass('noopen');
                        }, 1000)

                        // обновление фильтра
                        setTimeout(function () {
                            if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                                console.log('tyt ya');
                                $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                            }
                        }, 50)
                    }

                    // Отметка в календаре сразу после брони
                    setTimeout(function () {
                        if (dataAjax.status == 3) {
                            $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').addClass('particalRed').append('<span class="dp-note"></span>').click();
                            $(document).find('.open-el').attr('data-hash', Number(dataAjax.status));
                        } else if (dataAjax.status == 4) {
                            $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').addClass('red').click();
                            $(document).find('.open-el').attr('data-hash', Number(dataAjax.status));
                        }
                    }, 100)
                } else {
                    var result = data;
                    console.log(result);
                    dataBroned.openModal();
                    $('#data-broned p span').text($('#reserv-data .self__general-line.date span').text());
                }


            },
        });
    }

});

// Модалка Расчет банкета

$('.calc-main__form').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);
    var inpBl = $this.find('.input-block'),
        thisModal = $('#calc-main'),
        packetModal = $('#calc-packet');

    //  Типа валидация ////////////////////
    thisModal.find('.self__general-line.zal').removeClass('wrong');

    inpBl.each(function () {
        var thisInp = $(this).find('input, textarea');
        if (thisInp.val().length > 2) {
            thisInp.parents('.input-block').removeClass('wrong');
        } else {
            thisInp.parents('.input-block').addClass('wrong');
        }
    });

    thisModal.find('.simple-select').each(function () {
        var thisInp = $(this).find('input'),
            $thiss = $(this);
        if (thisInp.val().length == 0) {
            $thiss.addClass('wrong');
        } else {
            $thiss.removeClass('wrong');
        }
    });
    // Чтобы по любому был зал
    if (thisModal.find('.self__general-line.zal span').text().length == 0) {
        thisModal.find('.self__general-line.zal').addClass('wrong');
    }


    ////////////////////////////

    if ($this.find('.wrong').length == 0) {
        console.log('sub');

        var incId = '';
        if ($('#click_btn_id').val().length > 0) {
            incId = $('#click_btn_id').val();
        }

        var roomIdPrev = $('.calendar__top').find('input:checked').val();
        console.log(thisModal.find('.self__general-line.zal').data('zal-id'));

        if ($('main').hasClass('clients') && thisModal.find('.self__general-line.zal').data('zal-id').length > 0) {
            roomIdPrev = thisModal.find('.self__general-line.zal').data('zal-id');
            console.log(roomIdPrev);
        }

        let dataAjax = {
            guest_count: thisModal.find('#calc_main_guest').val(),
            date: $('#date_val').val(),
            room_id: roomIdPrev,
            name: thisModal.find('.name input').val(),
            phone: thisModal.find('.phone input').val(),
            event_type_id: thisModal.find('#calc_main_type').val(),
            status: 1,
            comment: thisModal.find('.input-block textarea').val(),
            source_id: thisModal.find('#calc_main_source').val(),
            inquiry_id: incId,
            _token: tokenData,
        }

        console.log(dataAjax);

        $.ajax({
            url: '/order/store',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;

                console.log(result);
                calcMain.closeModal();
                // $('#click_btn_id').val('');

                // Запись в кнопку копировать ссылку
                $('#sending .btn_copy').attr('data-copy', result.full_link);
                $('#sending .whatsapp-ajx b').text(result.client.phone);
                $('#sending .whatsapp-ajx').attr('href', 'https://api.whatsapp.com/send/?phone=' + result.client.phone + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + result.full_link + '');
                // console.log(result.client.email);
                if (result.client.email == 'none') {
                    $('#sending .btn_mail.btn-ajx').hide();
                } else {
                    $('#sending .btn_mail.btn-ajx').show();
                    $('#sending .btn_mail.btn-ajx').find('b').text(result.client.email)
                }

                // Предусмотрение, что если нет inquiry_id и он пришел по аяксу
                if (result.inquiry_id != undefined && $('#click_btn_id').val() == '') {
                    $('#click_btn_id').val(result.inquiry_id);
                }

                // Ордейр адйи в какой-то скрытый инпут на хранение
                $('#order_id').val(result.order_id);
                // Айди пакета
                $('#calc_packet_order_id').val(result.order_link);
                // console.log($('#calc_packet_order_id').val());

                // Сброс инпутов и селектов при сбросе формы
                // $this[0].reset();
                // inpBl.removeClass('noempty').find('input').val('');
                // resetSelect($this.find('.simple-select'));

                // Запись в скрытые инпуты в модалке пакетов
                packetModal.find('#calc_packet_zal').val(dataAjax.room_id);
                packetModal.find('#calc_packet_guest').val(dataAjax.guest_count);
                packetModal.find('#calc_packet_date').val(dataAjax.date);

                // Визуализация в модалке пакетов
                packetModal.find('.self__general-line.zal span').text(thisModal.find('.self__general-line.zal span').text());
                packetModal.find('.self__general-line.date span').text(thisModal.find('.self__general-line.date span').text());
                packetModal.find('.self__general-line.guest span').text(dataAjax.guest_count);
                packetModal.find('.self__general-line.name span').text(dataAjax.name);
                packetModal.find('.self__general-line_phone span').text(dataAjax.phone);

                $('.calc-packet__vars>.calc-packet__check').html('');

                $('.calc-packet__form').attr('action', '/menu/' + result.order_link)

                if (result.packs.length > 0) {
                    for (let index = 0; index < result.packs.length; index++) {
                        const pack = result.packs[index];

                        var eatWeight = pack.amount,
                            packDesr = pack.description;

                        // Выделение КГ и Грамм если больше 1000 грамм
                        if (eatWeight < 1001) {
                            var eatWeightWrite = `<span>${eatWeight} гр./чел.</span>`
                        } else {
                            // Превращение с троку иначе длинна не считается
                            var eStart = eatWeight.toString().length - 3,
                                eEnd = eatWeight.toString().length,
                                eatWeightGramm = eatWeight.toString().slice(eStart, eEnd),
                                eatWeightKg = (eatWeight / 1000).toString().split(".")[0];
                            var eatWeightWrite = `<span> ${eatWeightKg} кг. ${eatWeightGramm} гр./чел.</span>`
                        }

                        if (pack.description == null) {
                            packDesr = '';
                        }

                        $('.calc-packet__vars>.calc-packet__check').append(`
                            <label>
                                <input type="checkbox" name="pack_id" value="${pack.id}" hidden="">
                                <div class="check__contant">
                                    <div class="label">${pack.name}</div>
                                    <div class="checkbox__icon">
                                        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="check__contant-top">
                                        <p>${triplets(pack.cost)}₽</p>${eatWeightWrite}
                                    </div>
                                    <div class="calc-packet__cont">
                                        ${packDesr}
                                    </div>
                                    <a href="${result.order_link}" data-id="${pack.id}">Посмотреть меню и условия</a>
                                </div>
                            </label>
                        `);

                    }
                }

                // Очистка списка отправленных расчетов
                packetModal.find('.about-client__raschet').remove();

                // Вывод отправленных расчетов в модалку

                if (result.options != undefined) {
                    if (result.options.length > 0) {

                        packetModal.find('.calc-packet__vars').append(`
                            <div class="about-client__raschet">
                                <div class="about-client__calc-title">Индивидуальные расчеты для отправки</div>
                                <div class="calc-packet__check"></div>
                            </div>
                            `);

                        $('.about-client__raschet').show();
                        for (let index = 0; index < result.options.length; index++) {
                            const raschetItem = result.options[index];
                            var zalName = raschetItem.room,
                                itemDescr = raschetItem.description,
                                eatWeight = raschetItem.amount;

                            if (itemDescr == null) {
                                itemDescr = '';
                            }
                            // Выделение КГ и Грамм если больше 1000 грамм
                            if (eatWeight < 1001) {
                                var eatWeightWrite = `<span>${eatWeight} гр./чел.</span>`
                            } else {
                                // Превращение с троку иначе длинна не считается
                                var eStart = eatWeight.toString().length - 3,
                                    eEnd = eatWeight.toString().length,
                                    eatWeightGramm = eatWeight.toString().slice(eStart, eEnd),
                                    eatWeightKg = (eatWeight / 1000).toString().split(".")[0];
                                var eatWeightWrite = `<span> ${eatWeightKg} кг. ${eatWeightGramm} гр./чел.</span>`
                            }

                            // Если зала нет
                            if (raschetItem.room == null) {
                                zalName = '—'
                            }


                            $('.about-client__raschet .calc-packet__check').append(`
                                <label>
                                    <input type="checkbox" name="pack_rasch" value="${raschetItem.id}" hidden="">
                                    <div class="check__contant">
                                        <div class="label">${raschetItem.name}</div>
                                        <div class="checkbox__icon">
                                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.125 1.375L3.875 6.62477L1.25 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                        </div>
                                        <div class="check__contant-top">
                                            <p>${triplets(raschetItem.cost)}₽</p>${eatWeightWrite}
                                        </div>
                                        <div class="calc-packet__cont">
                                            ${itemDescr}
                                        </div>

                                    </div>
                                </label>
                            `);
                            // {/* <a href="${result.order.order_link}" data-id="${raschetItem.id}">Посмотреть меню и условия</a> */}
                        }

                    } else {
                        $('.about-client__raschet').hide();
                    }
                }

                calcPacket.openModal();

                thisModal.addClass('can-be-ajax');
                // Обновление календаря
                $(document).find('.calendar .day.active, .datepicker--cell-day.-selected-').click();
            }
        });
    }
});

// Клик по ссылке пакета в модалке пакета
$(document).on('click', '#calc-packet .check__contant a', function (e) {
    e.preventDefault();


    // Включение чекбокса в котором ссылка
    $('#calc-packet .calc-packet__vars').find('input[type=checkbox]').prop('checked', false)
    $(this).parents('label').find('input[type=checkbox]').prop('checked', true);
    var $this = $('.calc-packet__form');

    setTimeout(function () {
        $this[0].submit();
    }, 50)
});

// Открытие модалки подробнее по айди
$(document).on('click', '#watsappsend .sm-modal-body, #watsappsend .btn-close, #copylink .sm-modal-body, #copylink .btn-close, #pdfopen.can_detail_open .btn-close, #pdfopen.can_detail_open .sm-modal-body, #mail-yourself_pack_ready .sm-modal-body, #mail-yourself_pack_ready .btn-close', function (e) {
    e.preventDefault();
    // console.log('current Id = ' + currentOrderId);
    if (($('main').hasClass('self') && !$('#sending').hasClass('active')) || !$('main').hasClass('self')) {
        renderDetailedModal(currentOrderId);
    }
    // renderDetailedModal(currentOrderId);

    setTimeout(function () {
        mailYourselfPack.closeModal();
        calcPacket.closeModal();
        sending.closeModal();
    }, 50)

});


// Модалка куда отправить
$(document).on('click', '.btn-ajx', function (e) {

    var allPack = [],
        allOptions = [],
        thisBtn = $(this),
        sentType = '';

    if (!thisBtn.hasClass('whatsapp-ajx')) {
        e.preventDefault();
    }

    $('.calc-packet__vars>.calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allPack.push($this.val());
        }
    })

    $('.calc-packet__vars .about-client__raschet .calc-packet__check').find('input[type=checkbox]').each(function (e) {
        var $this = $(this)
        if ($this.is(':checked')) {
            allOptions.push($this.val());
        }
    })

    if (thisBtn.hasClass('whatsapp-ajx')) {
        sentType = 'whatsapp';
    } else if (thisBtn.hasClass('btn_mail')) {
        sentType = 'email';
    }

    // var inquiryId = '';

    if ($(document).find('#inqury_id').length > 0) {
        var inquiryId = $(document).find('#inqury_id').val();
    } else {
        var inquiryId = $('#click_btn_id').val();
    }


    let dataAjax = {
        order_link: $('#calc_packet_order_id').val(),
        packs: allPack,
        options: allOptions,
        email: $('#other_email').val(),
        whatsapp: $('#other_wathsapp').val(),
        date: $('#calc_packet_date').val(),
        guest_count: $('#calc_packet_guest').val(),
        room_id: $('#calc_packet_zal').val(),
        send_type: sentType,
        inquiry_id: inquiryId,
        _token: tokenData,
    }

    // console.log(dataAjax);
    // window.open('https://api.whatsapp.com/send/?phone=' + thisBtn.find('p b').text().replaceAll(' ', ''));

    $.ajax({
        url: '/order/send',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            // Для закрытия модалки с последубщим редиректом в календарь
            if ($('main').hasClass('self')) {
                $('#sending').addClass('can-redirect');
            }

            if ($('main').hasClass('clients')) {
                setTimeout(function () {
                    if ($('.applications__btns .applications__buttons-wrap').find('.applications__btn.active').length > 0) {
                        console.log('tyt ya');
                        $('.applications__btns .applications__buttons-wrap .applications__btn.active').click().click();
                    }
                }, 50)
            }

            setTimeout(function () {
                sending.closeModal();
            }, 500)

            console.log(thisBtn);
            if (thisBtn.hasClass('whatsapp-ajx')) {
                console.log(thisBtn.find('p b'));
                $('#watsappsend').find('p span').text(thisBtn.find('p b').text());
                watsappsend.openModal();

                // window.open('https://api.whatsapp.com/send/?phone=' + thisBtn.find('p b').text().replaceAll(' ', '') + '&text=%D0%9F%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D0%B0%D1%88%D0%B5%D0%B3%D0%BE%20%D0%B1%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D0%B0%3A%20 ' + $('#sending .btn_copy').attr('data-copy'));

            } else {
                $('#mailsend').find('p span').text(thisBtn.find('p b').text());
            }
        }
    })
});

// $(document).on('click', function () {
//     console.log($('#click_btn_id').val());
// })

// Расчет банкета из модалки подробнее
$(document).on('click', '#aboutClient .calc_banket', function (e) {
    e.preventDefault();
    calcMain.openModal();

    // Вывод гостей в селект
    var thisModal = $('#aboutClient'),
        thisBtn = $(this),
        calcModal = $('#calc-main'),
        guestList = calcModal.find('.simple-select_guest .simple-select__list'),
        thisBtnPar = thisBtn.parents('.check__contant');

    if (thisBtn.parents('.check__contant').length == 0) {
        thisBtnPar = thisBtn.parents('.sm-modal')
    }

    $('#click_btn_id').val(thisBtn.data('id'));
    if ($('main').hasClass('clients')) {
        $('#calc-main .self__general-line.zal').data('id-zal', $('.calendar__top').find('input[type="radio"]').val());
    }


    var dataAjax = {
        // inquiry_id: $('#click_btn_id').val(),
        _token: tokenData,
    };



    // Перенос данных в расчет банкета


    // console.log(dataAjax);




    setTimeout(function () {

        // console.log(thisBtnPar.find('.self__general-line.type').data('type'));

        // Предзаполнение полей   ...............

        // Если карточка родителя такая
        if (thisBtn.parents('.check__contant').length != 0) {
            var separDate = thisBtnPar.find('.check__contant-item_date').data('date').split('.');
            calcModal.find('.self__general-line.date span').text(replaceAlll(thisBtnPar.find('.check__contant-item_date').data('date'), '-', '.'));
            calcModal.find('.self__general-line.zal').data('zal-id', '' + thisBtnPar.find('.check__contant-item_zal').data('zal-id') + '');
            console.log(calcModal.find('.self__general-line.zal').data('zal-id'));
            $('#date_val').val(separDate[2] + '-' + separDate[1] + '-' + separDate[0]);
            calcModal.find('.self__general-line.zal span').text(thisBtn.parents('.check__contant').find('.check__contant-item_zal span').text());
            calcModal.find('.name input').val(thisBtnPar.parents('.sm-modal').find('.modal-title .name').text());
            calcModal.find('.name').addClass('noempty');
            calcModal.find('.phone input').val(thisBtnPar.parents('.sm-modal').find('.self__general-line.phone span').text());
            calcModal.find('.phone').addClass('noempty');
            calcModal.find('.simple-select_type .simple-select__item[data-value=' + thisBtnPar.parents('.sm-modal').find('.self__general-line.type').data('type') + ']').click();
            calcModal.find('.simple-select_source .simple-select__item[data-value=' + thisBtnPar.parents('.sm-modal').find('.order-source').data('source') + ']').click();
            calcModal.find('.simple-select_guest .simple-select__item[data-value=' + thisBtnPar.find('.check__contant-item_guest span').text() + ']').click();


        } else {

            // Ибо оно чето там ругалось
            setTimeout(function () {
                // Заполнение полей (если центральная кнопка)
                calcModal.find('.name input').val(thisBtnPar.find('.modal-title .name').text());
                calcModal.find('.name').addClass('noempty');
                calcModal.find('.phone input').val(thisBtnPar.find('.self__general-line.phone span').text());
                calcModal.find('.phone').addClass('noempty');
                calcModal.find('.simple-select_type .simple-select__item[data-value=' + thisBtnPar.find('.self__general-line.type').data('type') + ']').click();
                calcModal.find('.simple-select_source .simple-select__item[data-value=' + thisBtnPar.find('.order-source').data('source') + ']').click();
                calcModal.find('.simple-select_guest .simple-select__item[data-value=' + thisBtnPar.find('.self__general-line.guest span').text() + ']').click();
            }, 1100)
            //

        }


        if ($('#calc-main .self__general-line.zal').data('id-zal') != undefined) {
            $.ajax({
                url: '/option/room/limits/' + $('#calc-main .self__general-line.zal').data('id-zal'),
                type: 'POST',
                data: dataAjax,
                success: function (data) {


                    console.log(data);

                    // Очистка списка гостей
                    guestList.html('');
                    // Вывод списка с количеством гостей
                    for (let index = data.min; index < data.max + 1; index++) {
                        guestList.append(`<li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`);
                    }


                    // console.log(thisBtnPar);
                    // console.log(thisBtnPar.find('.about-client__info .self__general-line.guest span'));

                    if (thisBtnPar.find('.check__contant-item_guest span').text().length != 0) {
                        calcModal.find('.simple-select__item[data-value=' + thisBtnPar.find('.check__contant-item_guest span').text() + ']').click();
                    } else {
                        var guestNum = thisBtn.parents('.sm-modal').find('.about-client__info .self__general-line.guest span').text();

                        console.log(guestNum);
                        if (calcModal.find('.simple-select__item[data-value=' + guestNum + ']').length == 0) {
                            // Выбор первого значения из списка
                            guestList.find('.simple-select__item').eq(0).click();
                        } else {
                            // Если значение есть в списке, то выбираем его
                            guestList.find('.simple-select__item[data-value=' + guestNum + ']').click();
                        }

                    }
                }
            });
        }
    }, 100)




});

$(document).on('submit', '.after-var .calc-packet__form', function (e) {
    e.preventDefault();


    console.log('after-var');

    calcPacket.closeModal();
    sending.openModal();
});

// Отправление запроса в архив
$(document).on('click', '.to-archiv', function (e) {
    e.preventDefault();
    var $this = $(this),
        dataAjax = {
            _token: tokenData,
        },
        thisModal = $this.parents('.sm-modal');




    $.ajax({
        url: '/order/edit/inquiry/' + $this.data('id'),
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);
            $this.parents('.check__contant').fadeOut(250, function () {
                $this.parents('.check__contant').remove();
            });

            thisModal.find('.about-client__obrabot .about-client__list').append(`

                    <div class="check__contant">
                        <div class="label">Запрос от ${result.created_at}</div>
                        <div class="check__contant-list">
                        <div class="check__contant-item check__contant-item_zal">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 4.99908H11.9342C11.602 4.76234 11.2287 4.5894 10.8333 4.48908V4.16575L13.775 2.78908C13.8956 2.71434 13.9951 2.61006 14.0641 2.4861C14.1331 2.36214 14.1693 2.22262 14.1693 2.08075C14.1693 1.93887 14.1331 1.79935 14.0641 1.67539C13.9951 1.55143 13.8956 1.44715 13.775 1.37241L11.1083 0.122412C10.9001 0.0251222 10.6707 -0.0179906 10.4414 -0.00292445C10.2121 0.0121417 9.99028 0.0848986 9.79659 0.208593C9.6029 0.332287 9.4436 0.502909 9.33348 0.704621C9.22335 0.906333 9.16597 1.1326 9.16667 1.36241V4.48908C8.7715 4.58926 8.39846 4.76221 8.06667 4.99908H4.16667C3.062 5.0004 2.00296 5.43981 1.22185 6.22093C0.440735 7.00204 0.00132321 8.06108 0 9.16575L0 17.4991C0 18.1621 0.263392 18.798 0.732233 19.2668C1.20107 19.7357 1.83696 19.9991 2.5 19.9991H17.5C18.163 19.9991 18.7989 19.7357 19.2678 19.2668C19.7366 18.798 20 18.1621 20 17.4991V9.16575C19.9987 8.06108 19.5593 7.00204 18.7782 6.22093C17.997 5.43981 16.938 5.0004 15.8333 4.99908ZM18.18 8.33241H16.3808C15.7182 8.33072 15.0829 8.06748 14.6133 7.59991L13.6783 6.66575H15.8333C16.3486 6.66788 16.8505 6.82915 17.2706 7.12749C17.6906 7.42582 18.0083 7.84666 18.18 8.33241ZM4.16667 6.66575H6.32167L5.38667 7.59991C4.91706 8.06748 4.28184 8.33072 3.61917 8.33241H1.82C1.99174 7.84666 2.30936 7.42582 2.72942 7.12749C3.14948 6.82915 3.65145 6.66788 4.16667 6.66575ZM10.8333 18.3324H9.16667V15.8324C9.16667 15.6114 9.25446 15.3994 9.41074 15.2432C9.56702 15.0869 9.77899 14.9991 10 14.9991C10.221 14.9991 10.433 15.0869 10.5893 15.2432C10.7455 15.3994 10.8333 15.6114 10.8333 15.8324V18.3324ZM17.5 18.3324H12.5V15.8324C12.5 15.1694 12.2366 14.5335 11.7678 14.0646C11.2989 13.5958 10.663 13.3324 10 13.3324C9.33696 13.3324 8.70107 13.5958 8.23223 14.0646C7.76339 14.5335 7.5 15.1694 7.5 15.8324V18.3324H2.5C2.27899 18.3324 2.06702 18.2446 1.91074 18.0883C1.75446 17.9321 1.66667 17.7201 1.66667 17.4991V9.99908H3.61917C4.16651 10.0004 4.70869 9.89322 5.21434 9.68366C5.71999 9.47411 6.17906 9.16637 6.565 8.77824L8.82167 6.52241C9.13421 6.20996 9.55806 6.03443 10 6.03443C10.4419 6.03443 10.8658 6.20996 11.1783 6.52241L13.435 8.77824C13.8209 9.16637 14.28 9.47411 14.7857 9.68366C15.2913 9.89322 15.8335 10.0004 16.3808 9.99908H18.3333V17.4991C18.3333 17.7201 18.2455 17.9321 18.0893 18.0883C17.933 18.2446 17.721 18.3324 17.5 18.3324ZM5.83333 12.4991C5.83333 12.7201 5.74554 12.9321 5.58926 13.0883C5.43297 13.2446 5.22101 13.3324 5 13.3324H4.16667C3.94565 13.3324 3.73369 13.2446 3.57741 13.0883C3.42113 12.9321 3.33333 12.7201 3.33333 12.4991C3.33333 12.2781 3.42113 12.0661 3.57741 11.9098C3.73369 11.7535 3.94565 11.6657 4.16667 11.6657H5C5.22101 11.6657 5.43297 11.7535 5.58926 11.9098C5.74554 12.0661 5.83333 12.2781 5.83333 12.4991ZM5.83333 15.8324C5.83333 16.0534 5.74554 16.2654 5.58926 16.4217C5.43297 16.5779 5.22101 16.6657 5 16.6657H4.16667C3.94565 16.6657 3.73369 16.5779 3.57741 16.4217C3.42113 16.2654 3.33333 16.0534 3.33333 15.8324C3.33333 15.6114 3.42113 15.3994 3.57741 15.2432C3.73369 15.0869 3.94565 14.9991 4.16667 14.9991H5C5.22101 14.9991 5.43297 15.0869 5.58926 15.2432C5.74554 15.3994 5.83333 15.6114 5.83333 15.8324ZM16.6667 12.4991C16.6667 12.7201 16.5789 12.9321 16.4226 13.0883C16.2663 13.2446 16.0543 13.3324 15.8333 13.3324H15C14.779 13.3324 14.567 13.2446 14.4107 13.0883C14.2545 12.9321 14.1667 12.7201 14.1667 12.4991C14.1667 12.2781 14.2545 12.0661 14.4107 11.9098C14.567 11.7535 14.779 11.6657 15 11.6657H15.8333C16.0543 11.6657 16.2663 11.7535 16.4226 11.9098C16.5789 12.0661 16.6667 12.2781 16.6667 12.4991ZM16.6667 15.8324C16.6667 16.0534 16.5789 16.2654 16.4226 16.4217C16.2663 16.5779 16.0543 16.6657 15.8333 16.6657H15C14.779 16.6657 14.567 16.5779 14.4107 16.4217C14.2545 16.2654 14.1667 16.0534 14.1667 15.8324C14.1667 15.6114 14.2545 15.3994 14.4107 15.2432C14.567 15.0869 14.779 14.9991 15 14.9991H15.8333C16.0543 14.9991 16.2663 15.0869 16.4226 15.2432C16.5789 15.3994 16.6667 15.6114 16.6667 15.8324ZM11.6667 9.99908C11.6667 10.3287 11.5689 10.6509 11.3858 10.925C11.2026 11.1991 10.9423 11.4127 10.6378 11.5389C10.3333 11.665 9.99815 11.698 9.67485 11.6337C9.35155 11.5694 9.05458 11.4107 8.82149 11.1776C8.5884 10.9445 8.42967 10.6475 8.36536 10.3242C8.30105 10.0009 8.33405 9.66582 8.4602 9.36127C8.58635 9.05673 8.79997 8.79643 9.07405 8.6133C9.34813 8.43016 9.67036 8.33241 10 8.33241C10.442 8.33241 10.8659 8.50801 11.1785 8.82057C11.4911 9.13313 11.6667 9.55705 11.6667 9.99908Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Зал: <span>${result.room}</span></p>
                        </div>
                        <div class="check__contant-item check__contant-item_date" data-date="${result.date}">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z" fill="#ABB2C7"></path>
                                    <path d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M5.83398 13.75C6.52434 13.75 7.08398 13.1904 7.08398 12.5C7.08398 11.8096 6.52434 11.25 5.83398 11.25C5.14363 11.25 4.58398 11.8096 4.58398 12.5C4.58398 13.1904 5.14363 13.75 5.83398 13.75Z" fill="#ABB2C7"></path>
                                    <path d="M14.166 13.75C14.8564 13.75 15.416 13.1904 15.416 12.5C15.416 11.8096 14.8564 11.25 14.166 11.25C13.4757 11.25 12.916 11.8096 12.916 12.5C12.916 13.1904 13.4757 13.75 14.166 13.75Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Дата: <span>${replaceAlll(result.date, '-', '.')}</span></p>
                        </div>
                        <div class="check__contant-item check__contant-item_guset">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 10.8333C5.50832 10.8333 4.7833 10.6134 4.16661 10.2013C3.54993 9.78929 3.06928 9.20362 2.78545 8.5184C2.50162 7.83318 2.42736 7.07918 2.57206 6.35175C2.71675 5.62432 3.0739 4.95613 3.59835 4.43168C4.1228 3.90724 4.79098 3.55008 5.51841 3.40539C6.24584 3.2607 6.99984 3.33496 7.68506 3.61879C8.37029 3.90262 8.95596 4.38326 9.36801 4.99995C9.78007 5.61663 10 6.34166 10 7.08334C9.9989 8.07756 9.60345 9.03075 8.90043 9.73377C8.19741 10.4368 7.24422 10.8322 6.25 10.8333ZM6.25 5C5.83796 5 5.43516 5.12219 5.09256 5.35111C4.74996 5.58003 4.48293 5.9054 4.32525 6.28608C4.16757 6.66676 4.12631 7.08565 4.2067 7.48977C4.28708 7.8939 4.4855 8.26511 4.77686 8.55647C5.06822 8.84783 5.43943 9.04625 5.84356 9.12664C6.24769 9.20702 6.66658 9.16577 7.04726 9.00808C7.42794 8.8504 7.75331 8.58338 7.98223 8.24077C8.21115 7.89817 8.33333 7.49538 8.33333 7.08334C8.33333 6.5308 8.11384 6.0009 7.72314 5.6102C7.33244 5.2195 6.80253 5 6.25 5ZM12.5 19.1667V18.75C12.5 17.0924 11.8415 15.5027 10.6694 14.3306C9.49731 13.1585 7.9076 12.5 6.25 12.5C4.5924 12.5 3.00268 13.1585 1.83058 14.3306C0.65848 15.5027 0 17.0924 0 18.75L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V18.75C1.66667 17.5344 2.14955 16.3686 3.00909 15.5091C3.86864 14.6496 5.03442 14.1667 6.25 14.1667C7.46558 14.1667 8.63136 14.6496 9.49091 15.5091C10.3504 16.3686 10.8333 17.5344 10.8333 18.75V19.1667C10.8333 19.3877 10.9211 19.5996 11.0774 19.7559C11.2337 19.9122 11.4457 20 11.6667 20C11.8877 20 12.0996 19.9122 12.2559 19.7559C12.4122 19.5996 12.5 19.3877 12.5 19.1667ZM20 15C20 13.8739 19.674 12.7719 19.0614 11.827C18.4489 10.8821 17.5759 10.1347 16.5479 9.67497C15.5199 9.21529 14.3808 9.06299 13.2681 9.23645C12.1555 9.40991 11.1168 9.90172 10.2775 10.6525C10.1948 10.7252 10.1273 10.8135 10.079 10.9124C10.0306 11.0113 10.0023 11.1188 9.99573 11.2287C9.98915 11.3386 10.0044 11.4487 10.0406 11.5526C10.0768 11.6566 10.1333 11.7523 10.2067 11.8343C10.2801 11.9164 10.3691 11.983 10.4684 12.0305C10.5678 12.0779 10.6755 12.1052 10.7855 12.1108C10.8954 12.1163 11.0054 12.1 11.109 12.0629C11.2126 12.0257 11.3078 11.9684 11.3892 11.8942C11.9887 11.358 12.7306 11.0069 13.5253 10.8831C14.3201 10.7593 15.1336 10.8681 15.8678 11.1965C16.6021 11.5249 17.2255 12.0588 17.663 12.7337C18.1005 13.4086 18.3333 14.1957 18.3333 15C18.3333 15.221 18.4211 15.433 18.5774 15.5893C18.7337 15.7455 18.9457 15.8333 19.1667 15.8333C19.3877 15.8333 19.5996 15.7455 19.7559 15.5893C19.9122 15.433 20 15.221 20 15ZM14.5833 7.5C13.8417 7.5 13.1166 7.28007 12.4999 6.86801C11.8833 6.45596 11.4026 5.87029 11.1188 5.18506C10.835 4.49984 10.7607 3.74584 10.9054 3.01841C11.0501 2.29098 11.4072 1.6228 11.9317 1.09835C12.4561 0.573904 13.1243 0.216751 13.8517 0.0720569C14.5792 -0.0726377 15.3332 0.00162482 16.0184 0.285453C16.7036 0.569282 17.2893 1.04993 17.7013 1.66661C18.1134 2.2833 18.3333 3.00832 18.3333 3.75C18.3322 4.74423 17.9368 5.69741 17.2338 6.40043C16.5307 7.10346 15.5776 7.4989 14.5833 7.5ZM14.5833 1.66667C14.1713 1.66667 13.7685 1.78885 13.4259 2.01777C13.0833 2.24669 12.8163 2.57207 12.6586 2.95274C12.5009 3.33342 12.4596 3.75231 12.54 4.15644C12.6204 4.56057 12.8188 4.93178 13.1102 5.22314C13.4016 5.5145 13.7728 5.71292 14.1769 5.7933C14.581 5.87369 14.9999 5.83243 15.3806 5.67475C15.7613 5.51707 16.0866 5.25004 16.3156 4.90744C16.5445 4.56484 16.6667 4.16205 16.6667 3.75C16.6667 3.19747 16.4472 2.66756 16.0565 2.27686C15.6658 1.88616 15.1359 1.66667 14.5833 1.66667Z" fill="#ABB2C7"></path>
                                </svg>
                            <p>Гостей: <span>${result.guest_count}</span></p>
                        </div>
                        </div>
                    </div>
            `);
            // setTimeout(function () {
            //     $this.parents('.check__contant').remove();
            // }, 260)

        }
    })

});


// Чекбокс в модалке подробнее (был на просмотре зала)
$(document).on('change', '.about-client__views-right input[type=checkbox]', function (e) {
    var thisStatus = $(this).is(':checked'),
        openEl = $(document).find('.open-el'),
        checkedStatus = '';


    if (thisStatus == true) {
        checkedStatus = 1
    } else {
        checkedStatus = 0
    }


    var dataAjax = {
        order_id: openEl.find('.applications__el-top-btn').data('id'),
        is_room_checked: checkedStatus,
        _token: tokenData,
    }

    $.ajax({
        url: '/order/edit/room_check',
        type: 'POST',
        data: dataAjax,
        success: function (data) {
            var result = data;
            console.log(result);

            if (openEl.find('.viewed-hall').length > 0) {
                // Визуализация в карточке
                if (thisStatus == true) {
                    openEl.find('.viewed-hall').addClass('active');
                } else {
                    openEl.find('.viewed-hall').removeClass('active');
                }
            }

            // Обновление сетки (фильтров) при смене статуса зала
            if (document.querySelector('main').classList.contains('clients') && document.querySelector('.applications__buttons') != null) {
                document.querySelector('.applications__btn.active').click();
            }

        }
    });
});

// Рассчитать банкет - кнопка на карточке
$(document).on('click', '.applications__el-calculation:not(:disabled)', function (e) {

    e.preventDefault();
    var $this = $(this);

    if ($this.attr('disabled') !== 'disabled') {
        $this.attr('disabled', true);
        $this.css({
            'opacity': 0.5,
            'cursor': 'not-allowed'
        });
        $this.parents('.applications__el').find('.applications__el-top-btn').click();
        $('#aboutClient').addClass('novisible');
        console.log($('#aboutClient').find('.about-client__btns').find('.calc_banket'));
        setTimeout(function () {
            $('#aboutClient').find('.about-client__btns').find('.calc_banket').click();
            $this.removeAttr('disabled');
            $this.removeAttr('style');
        }, 1100);

        setTimeout(function () {
            $('#aboutClient').removeClass('novisible');
            aboutClient.closeModal();
        }, 1000);
    }




});


$(document).on('change', '#calc-date .calc-data__zal input', function (e) {
    var $this = $(this);

    if ($(document).find('.calendar__top').length > 0) {
        $(document).find('.calendar__top input[value=' + $this.val() + ']').siblings('label').click();
    }
});


// Удаление заявки и переход к форме расчета заявки
$(document).on('submit', '.you-shure__form', function (e) {
    e.preventDefault();

    if (!$('main').hasClass('self')) {
        var dataAjax = {
            order_id: $('#order_id').val(),
            _token: tokenData,
        }

        $.ajax({
            url: ' /order/delete',
            type: 'POST',
            data: dataAjax,
            success: function (data) {
                var result = data;
                console.log(result);

                calcMain.openModal();
                youShure.closeModal();
                calcPacket.closeModal();

            }
        });
    } else {

        if ($('.redirect-link_date').hasClass('preredirect')) {
            setCookie('zal_id1', $('#selected_zal').val());
        }

        setCookie('back_option_link', document.location.href);
        setCookie('guest_count1', $('#guest_col').val());
        setCookie('date_val1', $('#date_val1').val());
        setCookie('redirectino', true);
        setTimeout(function () {
            // console.log($('.redirect-link').eq(0).attr('href'));
            document.location.href = $('.redirect-link').eq(0).attr('href');
        }, 50)


    }


});


// Страница калькулятора - предзаполнение гостей в модалке
if ($('main').hasClass('self')) {
    $(window).on('load', function () {

        var guestModal = $('#change-guest'),
            guestList = guestModal.find('.simple-select__list');


        var dataAjax1 = {
            _token: tokenData,
        }

        $.ajax({
            url: '/option/room/limits/' + $('#selected_zal').val(),
            type: 'POST',
            data: dataAjax1,
            success: function (data) {
                console.log(data);

                // Очистка списка гостей
                guestList.html('');
                // Вывод списка с количеством гостей
                for (let index = data.min; index < data.max + 1; index++) {
                    guestList.append(`<li class="simple-select__item" data-value="${index}" role="option">${index} гостей</li>`);
                }
                // console.log($('#guest_col').val());
                // Выбор первого значения из списка
                guestList.find('.simple-select__item[data-value=' + $('#guest_col').val() + ']').click();
            }
        });

    });
}

// Открытие модалки подробнее при загрузке страницы
$(window).on('load', function (e) {

    console.log(getCookie('currentOrderId'));

    if (getCookie('currentOrderId') != undefined) {
        setTimeout(function () {
            renderDetailedModal(getCookie('currentOrderId'));
        }, 50);
        setTimeout(function () {
            deleteCookie('currentOrderId');
        }, 100)
    }

});
